import { query, lit, str, int, end, Match } from "fp-ts-routing/lib";
import * as E from "fp-ts/lib/Either";
import { pipe } from "fp-ts/lib/function";
import * as Ord from "fp-ts/lib/Ord";
import { Ord as stringOrd } from "fp-ts/lib/string";
import * as t from "io-ts";
import { BooleanFromString } from "io-ts-types/lib/BooleanFromString";
import { NumberFromString } from "io-ts-types/lib/NumberFromString";

import { literalNumberFromString } from "../../codecs/literalNumberFromString";
import { LocalDateC } from "../../codecs/localDate";
import { NoKeyOverlapC } from "../../codecs/noKeyOverlap";
import { Describe } from "../../fp-ts/lib/types/describe";
import { NullableToOptionalFields } from "../../fp-ts/Record";
import { debtProfile as imported38_debtProfile, debtProfile as imported24_debtProfile, draftMode as imported2_draftMode, debtProfile as imported32_debtProfile, menuItems as imported2_menuItems, debtProfile as imported36_debtProfile, debtProfile as imported40_debtProfile, debtProfile as imported26_debtProfile, debtProfile as imported28_debtProfile, debtProfile as imported42_debtProfile, debtProfile as imported44_debtProfile, debtProfile as imported30_debtProfile, debtProfile as imported34_debtProfile, debtProfile as imported46_debtProfile } from "./featureFlags";
import { issuerAdmin as imported226_issuerAdmin, issuerAdmin as imported216_issuerAdmin, issuerUser as imported182_issuerUser, issuerAdmin as imported180_issuerAdmin, issuerUser as imported144_issuerUser, issuerUser as imported164_issuerUser, issuerUser as imported178_issuerUser, issuerAdmin as imported210_issuerAdmin, issuerAdmin as imported126_issuerAdmin, issuerUser as imported200_issuerUser, issuerUser as imported112_issuerUser, issuerAdmin as imported194_issuerAdmin, issuerAdmin as imported140_issuerAdmin, issuerUser as imported146_issuerUser, issuerUser as imported190_issuerUser, issuerAdmin as imported170_issuerAdmin, issuerUser as imported132_issuerUser, issuerUser as imported138_issuerUser, issuerAdmin as imported174_issuerAdmin, issuerUser as imported124_issuerUser, issuerUser as imported186_issuerUser, issuerUser as imported154_issuerUser, issuerAdmin as imported152_issuerAdmin, issuerAdmin as imported212_issuerAdmin, issuerUser as imported140_issuerUser, issuerAdmin as imported144_issuerAdmin, issuerAdmin as imported202_issuerAdmin, issuerAdmin as imported224_issuerAdmin, issuerAdmin as imported188_issuerAdmin, issuerUser as imported114_issuerUser, issuerAdmin as imported138_issuerAdmin, issuerUser as imported204_issuerUser, issuerUser as imported110_issuerUser, issuerAdmin as imported228_issuerAdmin, issuerAdmin as imported220_issuerAdmin, issuerUser as imported192_issuerUser, issuerUser as imported208_issuerUser, issuerAdmin as imported130_issuerAdmin, issuerAdmin as imported192_issuerAdmin, issuerUser as imported202_issuerUser, issuerAdmin as imported206_issuerAdmin, issuerAdmin as imported142_issuerAdmin, issuerUser as imported196_issuerUser, issuerUser as imported172_issuerUser, issuerAdmin as imported208_issuerAdmin, issuerUser as imported180_issuerUser, issuerUser as imported150_issuerUser, issuerAdmin as imported120_issuerAdmin, issuerUser as imported106_issuerUser, issuerUser as imported128_issuerUser, issuerAdmin as imported196_issuerAdmin, issuerUser as imported148_issuerUser, issuerUser as imported188_issuerUser, issuerUser as imported108_issuerUser, issuerAdmin as imported136_issuerAdmin, issuerAdmin as imported150_issuerAdmin, issuerUser as imported174_issuerUser, issuerAdmin as imported148_issuerAdmin, issuerAdmin as imported158_issuerAdmin, issuerAdmin as imported184_issuerAdmin, issuerAdmin as imported186_issuerAdmin, issuerAdmin as imported176_issuerAdmin, issuerAdmin as imported118_issuerAdmin, issuerUser as imported116_issuerUser, issuerAdmin as imported122_issuerAdmin, issuerAdmin as imported200_issuerAdmin, issuerAdmin as imported172_issuerAdmin, issuerUser as imported120_issuerUser, issuerAdmin as imported134_issuerAdmin, issuerAdmin as imported230_issuerAdmin, issuerAdmin as imported190_issuerAdmin, issuerUser as imported166_issuerUser, issuerAdmin as imported218_issuerAdmin, issuerUser as imported184_issuerUser, issuerAdmin as imported162_issuerAdmin, issuerAdmin as imported178_issuerAdmin, issuerUser as imported136_issuerUser, issuerUser as imported168_issuerUser, issuerUser as imported160_issuerUser, issuerAdmin as imported168_issuerAdmin, issuerUser as imported122_issuerUser, issuerAdmin as imported198_issuerAdmin, issuerUser as imported206_issuerUser, issuerAdmin as imported214_issuerAdmin, issuerUser as imported126_issuerUser, issuerUser as imported118_issuerUser, issuerAdmin as imported154_issuerAdmin, issuerAdmin as imported204_issuerAdmin, issuerAdmin as imported156_issuerAdmin, issuerAdmin as imported146_issuerAdmin, issuerUser as imported194_issuerUser, issuerAdmin as imported164_issuerAdmin, issuerAdmin as imported160_issuerAdmin, issuerAdmin as imported166_issuerAdmin, issuerUser as imported134_issuerUser, issuerUser as imported156_issuerUser, issuerUser as imported162_issuerUser, issuerUser as imported170_issuerUser, issuerUser as imported142_issuerUser, issuerUser as imported158_issuerUser, issuerUser as imported130_issuerUser, issuerUser as imported198_issuerUser, issuerAdmin as imported132_issuerAdmin, issuerAdmin as imported182_issuerAdmin, issuerAdmin as imported124_issuerAdmin, issuerAdmin as imported128_issuerAdmin, issuerAdmin as imported222_issuerAdmin, issuerUser as imported152_issuerUser, issuerUser as imported176_issuerUser } from "./roles";


export const adminSettings = {
  _tag: `AdminSettings`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported106_issuerUser, imported118_issuerAdmin]
} as const;

export type AdminSettingsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`AdminSettings`>
}>;
export const adminSettingsTaggedC: AdminSettingsTaggedC = t.type({
  _tag: t.literal(`AdminSettings`)
});
export type AdminSettingsTagged = t.TypeOf<AdminSettingsTaggedC>;
export type AdminSettings = AdminSettingsTagged & typeof adminSettings;
export type AdminSettingsC = t.Type<AdminSettings, AdminSettingsTagged>;
export const adminSettingsC: AdminSettingsC = pipe(adminSettingsTaggedC, c => new t.Type<AdminSettings, AdminSettingsTagged>(
  `AdminSettings`,
  (u: unknown): u is AdminSettings => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, AdminSettings> => pipe(c.decode(u), E.map(x => ({ ...x, ...adminSettings }))),
  (x: AdminSettings): AdminSettingsTagged => ({ ...x, _tag: `AdminSettings`}),
)) satisfies t.Type<AdminSettings, unknown>;


export const adminUsers = {
  _tag: `AdminUsers`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported120_issuerAdmin]
} as const;

export type AdminUsersTaggedC = t.TypeC<{
  _tag: t.LiteralC<`AdminUsers`>
}>;
export const adminUsersTaggedC: AdminUsersTaggedC = t.type({
  _tag: t.literal(`AdminUsers`)
});
export type AdminUsersTagged = t.TypeOf<AdminUsersTaggedC>;
export type AdminUsers = AdminUsersTagged & typeof adminUsers;
export type AdminUsersC = t.Type<AdminUsers, AdminUsersTagged>;
export const adminUsersC: AdminUsersC = pipe(adminUsersTaggedC, c => new t.Type<AdminUsers, AdminUsersTagged>(
  `AdminUsers`,
  (u: unknown): u is AdminUsers => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, AdminUsers> => pipe(c.decode(u), E.map(x => ({ ...x, ...adminUsers }))),
  (x: AdminUsers): AdminUsersTagged => ({ ...x, _tag: `AdminUsers`}),
)) satisfies t.Type<AdminUsers, unknown>;


export const adminInvoices = {
  _tag: `AdminInvoices`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported122_issuerAdmin]
} as const;

export type AdminInvoicesTaggedC = t.TypeC<{
  _tag: t.LiteralC<`AdminInvoices`>
}>;
export const adminInvoicesTaggedC: AdminInvoicesTaggedC = t.type({
  _tag: t.literal(`AdminInvoices`)
});
export type AdminInvoicesTagged = t.TypeOf<AdminInvoicesTaggedC>;
export type AdminInvoices = AdminInvoicesTagged & typeof adminInvoices;
export type AdminInvoicesC = t.Type<AdminInvoices, AdminInvoicesTagged>;
export const adminInvoicesC: AdminInvoicesC = pipe(adminInvoicesTaggedC, c => new t.Type<AdminInvoices, AdminInvoicesTagged>(
  `AdminInvoices`,
  (u: unknown): u is AdminInvoices => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, AdminInvoices> => pipe(c.decode(u), E.map(x => ({ ...x, ...adminInvoices }))),
  (x: AdminInvoices): AdminInvoicesTagged => ({ ...x, _tag: `AdminInvoices`}),
)) satisfies t.Type<AdminInvoices, unknown>;


export const analyticsSiteActivity = {
  _tag: `AnalyticsSiteActivity`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported108_issuerUser, imported124_issuerAdmin]
} as const;

export type AnalyticsSiteActivityTaggedC = t.TypeC<{
  _tag: t.LiteralC<`AnalyticsSiteActivity`>
}>;
export const analyticsSiteActivityTaggedC: AnalyticsSiteActivityTaggedC = t.type({
  _tag: t.literal(`AnalyticsSiteActivity`)
});
export type AnalyticsSiteActivityTagged = t.TypeOf<AnalyticsSiteActivityTaggedC>;
export type AnalyticsSiteActivity = AnalyticsSiteActivityTagged & typeof analyticsSiteActivity;
export type AnalyticsSiteActivityC = t.Type<AnalyticsSiteActivity, AnalyticsSiteActivityTagged>;
export const analyticsSiteActivityC: AnalyticsSiteActivityC = pipe(analyticsSiteActivityTaggedC, c => new t.Type<AnalyticsSiteActivity, AnalyticsSiteActivityTagged>(
  `AnalyticsSiteActivity`,
  (u: unknown): u is AnalyticsSiteActivity => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, AnalyticsSiteActivity> => pipe(c.decode(u), E.map(x => ({ ...x, ...analyticsSiteActivity }))),
  (x: AnalyticsSiteActivity): AnalyticsSiteActivityTagged => ({ ...x, _tag: `AnalyticsSiteActivity`}),
)) satisfies t.Type<AnalyticsSiteActivity, unknown>;


export const analyticsUserActivity = {
  _tag: `AnalyticsUserActivity`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported110_issuerUser, imported126_issuerAdmin]
} as const;

export type AnalyticsUserActivityTaggedC = t.TypeC<{
  _tag: t.LiteralC<`AnalyticsUserActivity`>
}>;
export const analyticsUserActivityTaggedC: AnalyticsUserActivityTaggedC = t.type({
  _tag: t.literal(`AnalyticsUserActivity`)
});
export type AnalyticsUserActivityTagged = t.TypeOf<AnalyticsUserActivityTaggedC>;
export type AnalyticsUserActivity = AnalyticsUserActivityTagged & typeof analyticsUserActivity;
export type AnalyticsUserActivityC = t.Type<AnalyticsUserActivity, AnalyticsUserActivityTagged>;
export const analyticsUserActivityC: AnalyticsUserActivityC = pipe(analyticsUserActivityTaggedC, c => new t.Type<AnalyticsUserActivity, AnalyticsUserActivityTagged>(
  `AnalyticsUserActivity`,
  (u: unknown): u is AnalyticsUserActivity => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, AnalyticsUserActivity> => pipe(c.decode(u), E.map(x => ({ ...x, ...analyticsUserActivity }))),
  (x: AnalyticsUserActivity): AnalyticsUserActivityTagged => ({ ...x, _tag: `AnalyticsUserActivity`}),
)) satisfies t.Type<AnalyticsUserActivity, unknown>;


export const analyticsCustomReports = {
  _tag: `AnalyticsCustomReports`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported112_issuerUser, imported128_issuerAdmin]
} as const;

export type AnalyticsCustomReportsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`AnalyticsCustomReports`>
}>;
export const analyticsCustomReportsTaggedC: AnalyticsCustomReportsTaggedC = t.type({
  _tag: t.literal(`AnalyticsCustomReports`)
});
export type AnalyticsCustomReportsTagged = t.TypeOf<AnalyticsCustomReportsTaggedC>;
export type AnalyticsCustomReports = AnalyticsCustomReportsTagged & typeof analyticsCustomReports;
export type AnalyticsCustomReportsC = t.Type<AnalyticsCustomReports, AnalyticsCustomReportsTagged>;
export const analyticsCustomReportsC: AnalyticsCustomReportsC = pipe(analyticsCustomReportsTaggedC, c => new t.Type<AnalyticsCustomReports, AnalyticsCustomReportsTagged>(
  `AnalyticsCustomReports`,
  (u: unknown): u is AnalyticsCustomReports => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, AnalyticsCustomReports> => pipe(c.decode(u), E.map(x => ({ ...x, ...analyticsCustomReports }))),
  (x: AnalyticsCustomReports): AnalyticsCustomReportsTagged => ({ ...x, _tag: `AnalyticsCustomReports`}),
)) satisfies t.Type<AnalyticsCustomReports, unknown>;


export const analyticsEmails = {
  _tag: `AnalyticsEmails`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported114_issuerUser, imported130_issuerAdmin]
} as const;

export type AnalyticsEmailsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`AnalyticsEmails`>
}>;
export const analyticsEmailsTaggedC: AnalyticsEmailsTaggedC = t.type({
  _tag: t.literal(`AnalyticsEmails`)
});
export type AnalyticsEmailsTagged = t.TypeOf<AnalyticsEmailsTaggedC>;
export type AnalyticsEmails = AnalyticsEmailsTagged & typeof analyticsEmails;
export type AnalyticsEmailsC = t.Type<AnalyticsEmails, AnalyticsEmailsTagged>;
export const analyticsEmailsC: AnalyticsEmailsC = pipe(analyticsEmailsTaggedC, c => new t.Type<AnalyticsEmails, AnalyticsEmailsTagged>(
  `AnalyticsEmails`,
  (u: unknown): u is AnalyticsEmails => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, AnalyticsEmails> => pipe(c.decode(u), E.map(x => ({ ...x, ...analyticsEmails }))),
  (x: AnalyticsEmails): AnalyticsEmailsTagged => ({ ...x, _tag: `AnalyticsEmails`}),
)) satisfies t.Type<AnalyticsEmails, unknown>;


export const dashboard = {
  _tag: `Dashboard`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported116_issuerUser, imported132_issuerAdmin]
} as const;

export type DashboardTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Dashboard`>
}>;
export const dashboardTaggedC: DashboardTaggedC = t.type({
  _tag: t.literal(`Dashboard`)
});
export type DashboardTagged = t.TypeOf<DashboardTaggedC>;
export type Dashboard = DashboardTagged & typeof dashboard;
export type DashboardC = t.Type<Dashboard, DashboardTagged>;
export const dashboardC: DashboardC = pipe(dashboardTaggedC, c => new t.Type<Dashboard, DashboardTagged>(
  `Dashboard`,
  (u: unknown): u is Dashboard => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Dashboard> => pipe(c.decode(u), E.map(x => ({ ...x, ...dashboard }))),
  (x: Dashboard): DashboardTagged => ({ ...x, _tag: `Dashboard`}),
)) satisfies t.Type<Dashboard, unknown>;


export const debtDataDebtProfile = {
  _tag: `DebtDataDebtProfile`,
  bankAllowed: true,
  featuresRequired: [imported24_debtProfile],
  rolesAllowed: [imported118_issuerUser, imported134_issuerAdmin]
} as const;

export type DebtDataDebtProfileTaggedC = t.TypeC<{
  _tag: t.LiteralC<`DebtDataDebtProfile`>
}>;
export const debtDataDebtProfileTaggedC: DebtDataDebtProfileTaggedC = t.type({
  _tag: t.literal(`DebtDataDebtProfile`)
});
export type DebtDataDebtProfileTagged = t.TypeOf<DebtDataDebtProfileTaggedC>;
export type DebtDataDebtProfile = DebtDataDebtProfileTagged & typeof debtDataDebtProfile;
export type DebtDataDebtProfileC = t.Type<DebtDataDebtProfile, DebtDataDebtProfileTagged>;
export const debtDataDebtProfileC: DebtDataDebtProfileC = pipe(debtDataDebtProfileTaggedC, c => new t.Type<DebtDataDebtProfile, DebtDataDebtProfileTagged>(
  `DebtDataDebtProfile`,
  (u: unknown): u is DebtDataDebtProfile => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, DebtDataDebtProfile> => pipe(c.decode(u), E.map(x => ({ ...x, ...debtDataDebtProfile }))),
  (x: DebtDataDebtProfile): DebtDataDebtProfileTagged => ({ ...x, _tag: `DebtDataDebtProfile`}),
)) satisfies t.Type<DebtDataDebtProfile, unknown>;


export const debtDataDataManagement = {
  _tag: `DebtDataDataManagement`,
  bankAllowed: true,
  featuresRequired: [imported26_debtProfile],
  rolesAllowed: [imported120_issuerUser, imported136_issuerAdmin]
} as const;

export type DebtDataDataManagementTaggedC = t.TypeC<{
  _tag: t.LiteralC<`DebtDataDataManagement`>
}>;
export const debtDataDataManagementTaggedC: DebtDataDataManagementTaggedC = t.type({
  _tag: t.literal(`DebtDataDataManagement`)
});
export type DebtDataDataManagementTagged = t.TypeOf<DebtDataDataManagementTaggedC>;
export type DebtDataDataManagement = DebtDataDataManagementTagged & typeof debtDataDataManagement;
export type DebtDataDataManagementC = t.Type<DebtDataDataManagement, DebtDataDataManagementTagged>;
export const debtDataDataManagementC: DebtDataDataManagementC = pipe(debtDataDataManagementTaggedC, c => new t.Type<DebtDataDataManagement, DebtDataDataManagementTagged>(
  `DebtDataDataManagement`,
  (u: unknown): u is DebtDataDataManagement => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, DebtDataDataManagement> => pipe(c.decode(u), E.map(x => ({ ...x, ...debtDataDataManagement }))),
  (x: DebtDataDataManagement): DebtDataDataManagementTagged => ({ ...x, _tag: `DebtDataDataManagement`}),
)) satisfies t.Type<DebtDataDataManagement, unknown>;


export const debtDataReviewCenter = {
  _tag: `DebtDataReviewCenter`,
  bankAllowed: true,
  featuresRequired: [imported28_debtProfile],
  rolesAllowed: [imported138_issuerAdmin]
} as const;

export type DebtDataReviewCenterTaggedC = t.TypeC<{
  _tag: t.LiteralC<`DebtDataReviewCenter`>
}>;
export const debtDataReviewCenterTaggedC: DebtDataReviewCenterTaggedC = t.type({
  _tag: t.literal(`DebtDataReviewCenter`)
});
export type DebtDataReviewCenterTagged = t.TypeOf<DebtDataReviewCenterTaggedC>;
export type DebtDataReviewCenter = DebtDataReviewCenterTagged & typeof debtDataReviewCenter;
export type DebtDataReviewCenterC = t.Type<DebtDataReviewCenter, DebtDataReviewCenterTagged>;
export const debtDataReviewCenterC: DebtDataReviewCenterC = pipe(debtDataReviewCenterTaggedC, c => new t.Type<DebtDataReviewCenter, DebtDataReviewCenterTagged>(
  `DebtDataReviewCenter`,
  (u: unknown): u is DebtDataReviewCenter => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, DebtDataReviewCenter> => pipe(c.decode(u), E.map(x => ({ ...x, ...debtDataReviewCenter }))),
  (x: DebtDataReviewCenter): DebtDataReviewCenterTagged => ({ ...x, _tag: `DebtDataReviewCenter`}),
)) satisfies t.Type<DebtDataReviewCenter, unknown>;


export const debtDataSettings = {
  _tag: `DebtDataSettings`,
  bankAllowed: true,
  featuresRequired: [imported30_debtProfile],
  rolesAllowed: [imported122_issuerUser, imported140_issuerAdmin]
} as const;

export type DebtDataSettingsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`DebtDataSettings`>
}>;
export const debtDataSettingsTaggedC: DebtDataSettingsTaggedC = t.type({
  _tag: t.literal(`DebtDataSettings`)
});
export type DebtDataSettingsTagged = t.TypeOf<DebtDataSettingsTaggedC>;
export type DebtDataSettings = DebtDataSettingsTagged & typeof debtDataSettings;
export type DebtDataSettingsC = t.Type<DebtDataSettings, DebtDataSettingsTagged>;
export const debtDataSettingsC: DebtDataSettingsC = pipe(debtDataSettingsTaggedC, c => new t.Type<DebtDataSettings, DebtDataSettingsTagged>(
  `DebtDataSettings`,
  (u: unknown): u is DebtDataSettings => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, DebtDataSettings> => pipe(c.decode(u), E.map(x => ({ ...x, ...debtDataSettings }))),
  (x: DebtDataSettings): DebtDataSettingsTagged => ({ ...x, _tag: `DebtDataSettings`}),
)) satisfies t.Type<DebtDataSettings, unknown>;


export const marketInsights = {
  _tag: `MarketInsights`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported124_issuerUser, imported142_issuerAdmin]
} as const;

export type MarketInsightsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MarketInsights`>
}>;
export const marketInsightsTaggedC: MarketInsightsTaggedC = t.type({
  _tag: t.literal(`MarketInsights`)
});
export type MarketInsightsTagged = t.TypeOf<MarketInsightsTaggedC>;
export type MarketInsights = MarketInsightsTagged & typeof marketInsights;
export type MarketInsightsC = t.Type<MarketInsights, MarketInsightsTagged>;
export const marketInsightsC: MarketInsightsC = pipe(marketInsightsTaggedC, c => new t.Type<MarketInsights, MarketInsightsTagged>(
  `MarketInsights`,
  (u: unknown): u is MarketInsights => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MarketInsights> => pipe(c.decode(u), E.map(x => ({ ...x, ...marketInsights }))),
  (x: MarketInsights): MarketInsightsTagged => ({ ...x, _tag: `MarketInsights`}),
)) satisfies t.Type<MarketInsights, unknown>;


export const mySiteAbout = {
  _tag: `MySiteAbout`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported126_issuerUser, imported144_issuerAdmin]
} as const;

export type MySiteAboutTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteAbout`>
}>;
export const mySiteAboutTaggedC: MySiteAboutTaggedC = t.type({
  _tag: t.literal(`MySiteAbout`)
});
export type MySiteAboutTagged = t.TypeOf<MySiteAboutTaggedC>;
export type MySiteAbout = MySiteAboutTagged & typeof mySiteAbout;
export type MySiteAboutC = t.Type<MySiteAbout, MySiteAboutTagged>;
export const mySiteAboutC: MySiteAboutC = pipe(mySiteAboutTaggedC, c => new t.Type<MySiteAbout, MySiteAboutTagged>(
  `MySiteAbout`,
  (u: unknown): u is MySiteAbout => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteAbout> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteAbout }))),
  (x: MySiteAbout): MySiteAboutTagged => ({ ...x, _tag: `MySiteAbout`}),
)) satisfies t.Type<MySiteAbout, unknown>;


export const mySiteAboutEsgProgram = {
  _tag: `MySiteAboutEsgProgram`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported128_issuerUser, imported146_issuerAdmin]
} as const;

export type MySiteAboutEsgProgramTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteAboutEsgProgram`>
}>;
export const mySiteAboutEsgProgramTaggedC: MySiteAboutEsgProgramTaggedC = t.type({
  _tag: t.literal(`MySiteAboutEsgProgram`)
});
export type MySiteAboutEsgProgramTagged = t.TypeOf<MySiteAboutEsgProgramTaggedC>;
export type MySiteAboutEsgProgram = MySiteAboutEsgProgramTagged & typeof mySiteAboutEsgProgram;
export type MySiteAboutEsgProgramC = t.Type<MySiteAboutEsgProgram, MySiteAboutEsgProgramTagged>;
export const mySiteAboutEsgProgramC: MySiteAboutEsgProgramC = pipe(mySiteAboutEsgProgramTaggedC, c => new t.Type<MySiteAboutEsgProgram, MySiteAboutEsgProgramTagged>(
  `MySiteAboutEsgProgram`,
  (u: unknown): u is MySiteAboutEsgProgram => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteAboutEsgProgram> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteAboutEsgProgram }))),
  (x: MySiteAboutEsgProgram): MySiteAboutEsgProgramTagged => ({ ...x, _tag: `MySiteAboutEsgProgram`}),
)) satisfies t.Type<MySiteAboutEsgProgram, unknown>;


export const mySiteAboutNewsAndEvents = {
  _tag: `MySiteAboutNewsAndEvents`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported130_issuerUser, imported148_issuerAdmin]
} as const;

export type MySiteAboutNewsAndEventsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteAboutNewsAndEvents`>
}>;
export const mySiteAboutNewsAndEventsTaggedC: MySiteAboutNewsAndEventsTaggedC = t.type({
  _tag: t.literal(`MySiteAboutNewsAndEvents`)
});
export type MySiteAboutNewsAndEventsTagged = t.TypeOf<MySiteAboutNewsAndEventsTaggedC>;
export type MySiteAboutNewsAndEvents = MySiteAboutNewsAndEventsTagged & typeof mySiteAboutNewsAndEvents;
export type MySiteAboutNewsAndEventsC = t.Type<MySiteAboutNewsAndEvents, MySiteAboutNewsAndEventsTagged>;
export const mySiteAboutNewsAndEventsC: MySiteAboutNewsAndEventsC = pipe(mySiteAboutNewsAndEventsTaggedC, c => new t.Type<MySiteAboutNewsAndEvents, MySiteAboutNewsAndEventsTagged>(
  `MySiteAboutNewsAndEvents`,
  (u: unknown): u is MySiteAboutNewsAndEvents => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteAboutNewsAndEvents> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteAboutNewsAndEvents }))),
  (x: MySiteAboutNewsAndEvents): MySiteAboutNewsAndEventsTagged => ({ ...x, _tag: `MySiteAboutNewsAndEvents`}),
)) satisfies t.Type<MySiteAboutNewsAndEvents, unknown>;


export const mySiteAboutProjects = {
  _tag: `MySiteAboutProjects`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported132_issuerUser, imported150_issuerAdmin]
} as const;

export type MySiteAboutProjectsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteAboutProjects`>
}>;
export const mySiteAboutProjectsTaggedC: MySiteAboutProjectsTaggedC = t.type({
  _tag: t.literal(`MySiteAboutProjects`)
});
export type MySiteAboutProjectsTagged = t.TypeOf<MySiteAboutProjectsTaggedC>;
export type MySiteAboutProjects = MySiteAboutProjectsTagged & typeof mySiteAboutProjects;
export type MySiteAboutProjectsC = t.Type<MySiteAboutProjects, MySiteAboutProjectsTagged>;
export const mySiteAboutProjectsC: MySiteAboutProjectsC = pipe(mySiteAboutProjectsTaggedC, c => new t.Type<MySiteAboutProjects, MySiteAboutProjectsTagged>(
  `MySiteAboutProjects`,
  (u: unknown): u is MySiteAboutProjects => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteAboutProjects> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteAboutProjects }))),
  (x: MySiteAboutProjects): MySiteAboutProjectsTagged => ({ ...x, _tag: `MySiteAboutProjects`}),
)) satisfies t.Type<MySiteAboutProjects, unknown>;


export const mySiteAboutTeam = {
  _tag: `MySiteAboutTeam`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported134_issuerUser, imported152_issuerAdmin]
} as const;

export type MySiteAboutTeamTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteAboutTeam`>
}>;
export const mySiteAboutTeamTaggedC: MySiteAboutTeamTaggedC = t.type({
  _tag: t.literal(`MySiteAboutTeam`)
});
export type MySiteAboutTeamTagged = t.TypeOf<MySiteAboutTeamTaggedC>;
export type MySiteAboutTeam = MySiteAboutTeamTagged & typeof mySiteAboutTeam;
export type MySiteAboutTeamC = t.Type<MySiteAboutTeam, MySiteAboutTeamTagged>;
export const mySiteAboutTeamC: MySiteAboutTeamC = pipe(mySiteAboutTeamTaggedC, c => new t.Type<MySiteAboutTeam, MySiteAboutTeamTagged>(
  `MySiteAboutTeam`,
  (u: unknown): u is MySiteAboutTeam => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteAboutTeam> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteAboutTeam }))),
  (x: MySiteAboutTeam): MySiteAboutTeamTagged => ({ ...x, _tag: `MySiteAboutTeam`}),
)) satisfies t.Type<MySiteAboutTeam, unknown>;


export const mySiteBonds = {
  _tag: `MySiteBonds`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported136_issuerUser, imported154_issuerAdmin]
} as const;

export type MySiteBondsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteBonds`>
}>;
export const mySiteBondsTaggedC: MySiteBondsTaggedC = t.type({
  _tag: t.literal(`MySiteBonds`)
});
export type MySiteBondsTagged = t.TypeOf<MySiteBondsTaggedC>;
export type MySiteBonds = MySiteBondsTagged & typeof mySiteBonds;
export type MySiteBondsC = t.Type<MySiteBonds, MySiteBondsTagged>;
export const mySiteBondsC: MySiteBondsC = pipe(mySiteBondsTaggedC, c => new t.Type<MySiteBonds, MySiteBondsTagged>(
  `MySiteBonds`,
  (u: unknown): u is MySiteBonds => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteBonds> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteBonds }))),
  (x: MySiteBonds): MySiteBondsTagged => ({ ...x, _tag: `MySiteBonds`}),
)) satisfies t.Type<MySiteBonds, unknown>;


export const mySiteBondsParticipants = {
  _tag: `MySiteBondsParticipants`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported138_issuerUser, imported156_issuerAdmin]
} as const;

export type MySiteBondsParticipantsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteBondsParticipants`>
}>;
export const mySiteBondsParticipantsTaggedC: MySiteBondsParticipantsTaggedC = t.type({
  _tag: t.literal(`MySiteBondsParticipants`)
});
export type MySiteBondsParticipantsTagged = t.TypeOf<MySiteBondsParticipantsTaggedC>;
export type MySiteBondsParticipants = MySiteBondsParticipantsTagged & typeof mySiteBondsParticipants;
export type MySiteBondsParticipantsC = t.Type<MySiteBondsParticipants, MySiteBondsParticipantsTagged>;
export const mySiteBondsParticipantsC: MySiteBondsParticipantsC = pipe(mySiteBondsParticipantsTaggedC, c => new t.Type<MySiteBondsParticipants, MySiteBondsParticipantsTagged>(
  `MySiteBondsParticipants`,
  (u: unknown): u is MySiteBondsParticipants => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteBondsParticipants> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteBondsParticipants }))),
  (x: MySiteBondsParticipants): MySiteBondsParticipantsTagged => ({ ...x, _tag: `MySiteBondsParticipants`}),
)) satisfies t.Type<MySiteBondsParticipants, unknown>;


export const mySiteBondsRatings = {
  _tag: `MySiteBondsRatings`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported140_issuerUser, imported158_issuerAdmin]
} as const;

export type MySiteBondsRatingsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteBondsRatings`>
}>;
export const mySiteBondsRatingsTaggedC: MySiteBondsRatingsTaggedC = t.type({
  _tag: t.literal(`MySiteBondsRatings`)
});
export type MySiteBondsRatingsTagged = t.TypeOf<MySiteBondsRatingsTaggedC>;
export type MySiteBondsRatings = MySiteBondsRatingsTagged & typeof mySiteBondsRatings;
export type MySiteBondsRatingsC = t.Type<MySiteBondsRatings, MySiteBondsRatingsTagged>;
export const mySiteBondsRatingsC: MySiteBondsRatingsC = pipe(mySiteBondsRatingsTaggedC, c => new t.Type<MySiteBondsRatings, MySiteBondsRatingsTagged>(
  `MySiteBondsRatings`,
  (u: unknown): u is MySiteBondsRatings => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteBondsRatings> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteBondsRatings }))),
  (x: MySiteBondsRatings): MySiteBondsRatingsTagged => ({ ...x, _tag: `MySiteBondsRatings`}),
)) satisfies t.Type<MySiteBondsRatings, unknown>;


export const mySiteBondsRoadshows = {
  _tag: `MySiteBondsRoadshows`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported142_issuerUser, imported160_issuerAdmin]
} as const;

export type MySiteBondsRoadshowsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteBondsRoadshows`>
}>;
export const mySiteBondsRoadshowsTaggedC: MySiteBondsRoadshowsTaggedC = t.type({
  _tag: t.literal(`MySiteBondsRoadshows`)
});
export type MySiteBondsRoadshowsTagged = t.TypeOf<MySiteBondsRoadshowsTaggedC>;
export type MySiteBondsRoadshows = MySiteBondsRoadshowsTagged & typeof mySiteBondsRoadshows;
export type MySiteBondsRoadshowsC = t.Type<MySiteBondsRoadshows, MySiteBondsRoadshowsTagged>;
export const mySiteBondsRoadshowsC: MySiteBondsRoadshowsC = pipe(mySiteBondsRoadshowsTaggedC, c => new t.Type<MySiteBondsRoadshows, MySiteBondsRoadshowsTagged>(
  `MySiteBondsRoadshows`,
  (u: unknown): u is MySiteBondsRoadshows => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteBondsRoadshows> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteBondsRoadshows }))),
  (x: MySiteBondsRoadshows): MySiteBondsRoadshowsTagged => ({ ...x, _tag: `MySiteBondsRoadshows`}),
)) satisfies t.Type<MySiteBondsRoadshows, unknown>;


export const mySiteBondsRfps = {
  _tag: `MySiteBondsRfps`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported144_issuerUser, imported162_issuerAdmin]
} as const;

export type MySiteBondsRfpsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteBondsRfps`>
}>;
export const mySiteBondsRfpsTaggedC: MySiteBondsRfpsTaggedC = t.type({
  _tag: t.literal(`MySiteBondsRfps`)
});
export type MySiteBondsRfpsTagged = t.TypeOf<MySiteBondsRfpsTaggedC>;
export type MySiteBondsRfps = MySiteBondsRfpsTagged & typeof mySiteBondsRfps;
export type MySiteBondsRfpsC = t.Type<MySiteBondsRfps, MySiteBondsRfpsTagged>;
export const mySiteBondsRfpsC: MySiteBondsRfpsC = pipe(mySiteBondsRfpsTaggedC, c => new t.Type<MySiteBondsRfps, MySiteBondsRfpsTagged>(
  `MySiteBondsRfps`,
  (u: unknown): u is MySiteBondsRfps => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteBondsRfps> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteBondsRfps }))),
  (x: MySiteBondsRfps): MySiteBondsRfpsTagged => ({ ...x, _tag: `MySiteBondsRfps`}),
)) satisfies t.Type<MySiteBondsRfps, unknown>;


export const mySiteBondsPrograms = {
  _tag: `MySiteBondsPrograms`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported146_issuerUser, imported164_issuerAdmin]
} as const;

export type MySiteBondsProgramsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteBondsPrograms`>
}>;
export const mySiteBondsProgramsTaggedC: MySiteBondsProgramsTaggedC = t.type({
  _tag: t.literal(`MySiteBondsPrograms`)
});
export type MySiteBondsProgramsTagged = t.TypeOf<MySiteBondsProgramsTaggedC>;
export type MySiteBondsPrograms = MySiteBondsProgramsTagged & typeof mySiteBondsPrograms;
export type MySiteBondsProgramsC = t.Type<MySiteBondsPrograms, MySiteBondsProgramsTagged>;
export const mySiteBondsProgramsC: MySiteBondsProgramsC = pipe(mySiteBondsProgramsTaggedC, c => new t.Type<MySiteBondsPrograms, MySiteBondsProgramsTagged>(
  `MySiteBondsPrograms`,
  (u: unknown): u is MySiteBondsPrograms => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteBondsPrograms> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteBondsPrograms }))),
  (x: MySiteBondsPrograms): MySiteBondsProgramsTagged => ({ ...x, _tag: `MySiteBondsPrograms`}),
)) satisfies t.Type<MySiteBondsPrograms, unknown>;


export const mySiteChangeApproval = {
  _tag: `MySiteChangeApproval`,
  bankAllowed: true,
  featuresRequired: [imported2_draftMode],
  rolesAllowed: [imported166_issuerAdmin]
} as const;

export type MySiteChangeApprovalTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteChangeApproval`>
}>;
export const mySiteChangeApprovalTaggedC: MySiteChangeApprovalTaggedC = t.type({
  _tag: t.literal(`MySiteChangeApproval`)
});
export type MySiteChangeApprovalTagged = t.TypeOf<MySiteChangeApprovalTaggedC>;
export type MySiteChangeApproval = MySiteChangeApprovalTagged & typeof mySiteChangeApproval;
export type MySiteChangeApprovalC = t.Type<MySiteChangeApproval, MySiteChangeApprovalTagged>;
export const mySiteChangeApprovalC: MySiteChangeApprovalC = pipe(mySiteChangeApprovalTaggedC, c => new t.Type<MySiteChangeApproval, MySiteChangeApprovalTagged>(
  `MySiteChangeApproval`,
  (u: unknown): u is MySiteChangeApproval => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteChangeApproval> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteChangeApproval }))),
  (x: MySiteChangeApproval): MySiteChangeApprovalTagged => ({ ...x, _tag: `MySiteChangeApproval`}),
)) satisfies t.Type<MySiteChangeApproval, unknown>;


export const mySiteCustomPages = {
  _tag: `MySiteCustomPages`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported148_issuerUser, imported168_issuerAdmin]
} as const;

export type MySiteCustomPagesTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteCustomPages`>
}>;
export const mySiteCustomPagesTaggedC: MySiteCustomPagesTaggedC = t.type({
  _tag: t.literal(`MySiteCustomPages`)
});
export type MySiteCustomPagesTagged = t.TypeOf<MySiteCustomPagesTaggedC>;
export type MySiteCustomPages = MySiteCustomPagesTagged & typeof mySiteCustomPages;
export type MySiteCustomPagesC = t.Type<MySiteCustomPages, MySiteCustomPagesTagged>;
export const mySiteCustomPagesC: MySiteCustomPagesC = pipe(mySiteCustomPagesTaggedC, c => new t.Type<MySiteCustomPages, MySiteCustomPagesTagged>(
  `MySiteCustomPages`,
  (u: unknown): u is MySiteCustomPages => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteCustomPages> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteCustomPages }))),
  (x: MySiteCustomPages): MySiteCustomPagesTagged => ({ ...x, _tag: `MySiteCustomPages`}),
)) satisfies t.Type<MySiteCustomPages, unknown>;


export const mySiteDocuments = {
  _tag: `MySiteDocuments`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported150_issuerUser, imported170_issuerAdmin]
} as const;

export type MySiteDocumentsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteDocuments`>
}>;
export const mySiteDocumentsTaggedC: MySiteDocumentsTaggedC = t.type({
  _tag: t.literal(`MySiteDocuments`)
});
export type MySiteDocumentsTagged = t.TypeOf<MySiteDocumentsTaggedC>;
export type MySiteDocuments = MySiteDocumentsTagged & typeof mySiteDocuments;
export type MySiteDocumentsC = t.Type<MySiteDocuments, MySiteDocumentsTagged>;
export const mySiteDocumentsC: MySiteDocumentsC = pipe(mySiteDocumentsTaggedC, c => new t.Type<MySiteDocuments, MySiteDocumentsTagged>(
  `MySiteDocuments`,
  (u: unknown): u is MySiteDocuments => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteDocuments> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteDocuments }))),
  (x: MySiteDocuments): MySiteDocumentsTagged => ({ ...x, _tag: `MySiteDocuments`}),
)) satisfies t.Type<MySiteDocuments, unknown>;


export const mySiteDocumentsCategories = {
  _tag: `MySiteDocumentsCategories`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported152_issuerUser, imported172_issuerAdmin]
} as const;

export type MySiteDocumentsCategoriesTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteDocumentsCategories`>
}>;
export const mySiteDocumentsCategoriesTaggedC: MySiteDocumentsCategoriesTaggedC = t.type({
  _tag: t.literal(`MySiteDocumentsCategories`)
});
export type MySiteDocumentsCategoriesTagged = t.TypeOf<MySiteDocumentsCategoriesTaggedC>;
export type MySiteDocumentsCategories = MySiteDocumentsCategoriesTagged & typeof mySiteDocumentsCategories;
export type MySiteDocumentsCategoriesC = t.Type<MySiteDocumentsCategories, MySiteDocumentsCategoriesTagged>;
export const mySiteDocumentsCategoriesC: MySiteDocumentsCategoriesC = pipe(mySiteDocumentsCategoriesTaggedC, c => new t.Type<MySiteDocumentsCategories, MySiteDocumentsCategoriesTagged>(
  `MySiteDocumentsCategories`,
  (u: unknown): u is MySiteDocumentsCategories => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteDocumentsCategories> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteDocumentsCategories }))),
  (x: MySiteDocumentsCategories): MySiteDocumentsCategoriesTagged => ({ ...x, _tag: `MySiteDocumentsCategories`}),
)) satisfies t.Type<MySiteDocumentsCategories, unknown>;


export const mySiteDocumentsIrmaLetter = {
  _tag: `MySiteDocumentsIrmaLetter`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported154_issuerUser, imported174_issuerAdmin]
} as const;

export type MySiteDocumentsIrmaLetterTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteDocumentsIrmaLetter`>
}>;
export const mySiteDocumentsIrmaLetterTaggedC: MySiteDocumentsIrmaLetterTaggedC = t.type({
  _tag: t.literal(`MySiteDocumentsIrmaLetter`)
});
export type MySiteDocumentsIrmaLetterTagged = t.TypeOf<MySiteDocumentsIrmaLetterTaggedC>;
export type MySiteDocumentsIrmaLetter = MySiteDocumentsIrmaLetterTagged & typeof mySiteDocumentsIrmaLetter;
export type MySiteDocumentsIrmaLetterC = t.Type<MySiteDocumentsIrmaLetter, MySiteDocumentsIrmaLetterTagged>;
export const mySiteDocumentsIrmaLetterC: MySiteDocumentsIrmaLetterC = pipe(mySiteDocumentsIrmaLetterTaggedC, c => new t.Type<MySiteDocumentsIrmaLetter, MySiteDocumentsIrmaLetterTagged>(
  `MySiteDocumentsIrmaLetter`,
  (u: unknown): u is MySiteDocumentsIrmaLetter => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteDocumentsIrmaLetter> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteDocumentsIrmaLetter }))),
  (x: MySiteDocumentsIrmaLetter): MySiteDocumentsIrmaLetterTagged => ({ ...x, _tag: `MySiteDocumentsIrmaLetter`}),
)) satisfies t.Type<MySiteDocumentsIrmaLetter, unknown>;


export const mySiteHome = {
  _tag: `MySiteHome`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported156_issuerUser, imported176_issuerAdmin]
} as const;

export type MySiteHomeTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteHome`>
}>;
export const mySiteHomeTaggedC: MySiteHomeTaggedC = t.type({
  _tag: t.literal(`MySiteHome`)
});
export type MySiteHomeTagged = t.TypeOf<MySiteHomeTaggedC>;
export type MySiteHome = MySiteHomeTagged & typeof mySiteHome;
export type MySiteHomeC = t.Type<MySiteHome, MySiteHomeTagged>;
export const mySiteHomeC: MySiteHomeC = pipe(mySiteHomeTaggedC, c => new t.Type<MySiteHome, MySiteHomeTagged>(
  `MySiteHome`,
  (u: unknown): u is MySiteHome => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteHome> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteHome }))),
  (x: MySiteHome): MySiteHomeTagged => ({ ...x, _tag: `MySiteHome`}),
)) satisfies t.Type<MySiteHome, unknown>;


export const mySiteResourcesCusip9s = {
  _tag: `MySiteResourcesCusip9s`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported158_issuerUser, imported178_issuerAdmin]
} as const;

export type MySiteResourcesCusip9sTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteResourcesCusip9s`>
}>;
export const mySiteResourcesCusip9sTaggedC: MySiteResourcesCusip9sTaggedC = t.type({
  _tag: t.literal(`MySiteResourcesCusip9s`)
});
export type MySiteResourcesCusip9sTagged = t.TypeOf<MySiteResourcesCusip9sTaggedC>;
export type MySiteResourcesCusip9s = MySiteResourcesCusip9sTagged & typeof mySiteResourcesCusip9s;
export type MySiteResourcesCusip9sC = t.Type<MySiteResourcesCusip9s, MySiteResourcesCusip9sTagged>;
export const mySiteResourcesCusip9sC: MySiteResourcesCusip9sC = pipe(mySiteResourcesCusip9sTaggedC, c => new t.Type<MySiteResourcesCusip9s, MySiteResourcesCusip9sTagged>(
  `MySiteResourcesCusip9s`,
  (u: unknown): u is MySiteResourcesCusip9s => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteResourcesCusip9s> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteResourcesCusip9s }))),
  (x: MySiteResourcesCusip9s): MySiteResourcesCusip9sTagged => ({ ...x, _tag: `MySiteResourcesCusip9s`}),
)) satisfies t.Type<MySiteResourcesCusip9s, unknown>;


export const mySiteResourcesCusip6s = {
  _tag: `MySiteResourcesCusip6s`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported160_issuerUser, imported180_issuerAdmin]
} as const;

export type MySiteResourcesCusip6sTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteResourcesCusip6s`>
}>;
export const mySiteResourcesCusip6sTaggedC: MySiteResourcesCusip6sTaggedC = t.type({
  _tag: t.literal(`MySiteResourcesCusip6s`)
});
export type MySiteResourcesCusip6sTagged = t.TypeOf<MySiteResourcesCusip6sTaggedC>;
export type MySiteResourcesCusip6s = MySiteResourcesCusip6sTagged & typeof mySiteResourcesCusip6s;
export type MySiteResourcesCusip6sC = t.Type<MySiteResourcesCusip6s, MySiteResourcesCusip6sTagged>;
export const mySiteResourcesCusip6sC: MySiteResourcesCusip6sC = pipe(mySiteResourcesCusip6sTaggedC, c => new t.Type<MySiteResourcesCusip6s, MySiteResourcesCusip6sTagged>(
  `MySiteResourcesCusip6s`,
  (u: unknown): u is MySiteResourcesCusip6s => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteResourcesCusip6s> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteResourcesCusip6s }))),
  (x: MySiteResourcesCusip6s): MySiteResourcesCusip6sTagged => ({ ...x, _tag: `MySiteResourcesCusip6s`}),
)) satisfies t.Type<MySiteResourcesCusip6s, unknown>;


export const mySiteResourcesFaqs = {
  _tag: `MySiteResourcesFaqs`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported162_issuerUser, imported182_issuerAdmin]
} as const;

export type MySiteResourcesFaqsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteResourcesFaqs`>
}>;
export const mySiteResourcesFaqsTaggedC: MySiteResourcesFaqsTaggedC = t.type({
  _tag: t.literal(`MySiteResourcesFaqs`)
});
export type MySiteResourcesFaqsTagged = t.TypeOf<MySiteResourcesFaqsTaggedC>;
export type MySiteResourcesFaqs = MySiteResourcesFaqsTagged & typeof mySiteResourcesFaqs;
export type MySiteResourcesFaqsC = t.Type<MySiteResourcesFaqs, MySiteResourcesFaqsTagged>;
export const mySiteResourcesFaqsC: MySiteResourcesFaqsC = pipe(mySiteResourcesFaqsTaggedC, c => new t.Type<MySiteResourcesFaqs, MySiteResourcesFaqsTagged>(
  `MySiteResourcesFaqs`,
  (u: unknown): u is MySiteResourcesFaqs => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteResourcesFaqs> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteResourcesFaqs }))),
  (x: MySiteResourcesFaqs): MySiteResourcesFaqsTagged => ({ ...x, _tag: `MySiteResourcesFaqs`}),
)) satisfies t.Type<MySiteResourcesFaqs, unknown>;


export const mySiteResourcesLinks = {
  _tag: `MySiteResourcesLinks`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported164_issuerUser, imported184_issuerAdmin]
} as const;

export type MySiteResourcesLinksTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteResourcesLinks`>
}>;
export const mySiteResourcesLinksTaggedC: MySiteResourcesLinksTaggedC = t.type({
  _tag: t.literal(`MySiteResourcesLinks`)
});
export type MySiteResourcesLinksTagged = t.TypeOf<MySiteResourcesLinksTaggedC>;
export type MySiteResourcesLinks = MySiteResourcesLinksTagged & typeof mySiteResourcesLinks;
export type MySiteResourcesLinksC = t.Type<MySiteResourcesLinks, MySiteResourcesLinksTagged>;
export const mySiteResourcesLinksC: MySiteResourcesLinksC = pipe(mySiteResourcesLinksTaggedC, c => new t.Type<MySiteResourcesLinks, MySiteResourcesLinksTagged>(
  `MySiteResourcesLinks`,
  (u: unknown): u is MySiteResourcesLinks => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteResourcesLinks> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteResourcesLinks }))),
  (x: MySiteResourcesLinks): MySiteResourcesLinksTagged => ({ ...x, _tag: `MySiteResourcesLinks`}),
)) satisfies t.Type<MySiteResourcesLinks, unknown>;


export const mySiteResourcesContact = {
  _tag: `MySiteResourcesContact`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported166_issuerUser, imported186_issuerAdmin]
} as const;

export type MySiteResourcesContactTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteResourcesContact`>
}>;
export const mySiteResourcesContactTaggedC: MySiteResourcesContactTaggedC = t.type({
  _tag: t.literal(`MySiteResourcesContact`)
});
export type MySiteResourcesContactTagged = t.TypeOf<MySiteResourcesContactTaggedC>;
export type MySiteResourcesContact = MySiteResourcesContactTagged & typeof mySiteResourcesContact;
export type MySiteResourcesContactC = t.Type<MySiteResourcesContact, MySiteResourcesContactTagged>;
export const mySiteResourcesContactC: MySiteResourcesContactC = pipe(mySiteResourcesContactTaggedC, c => new t.Type<MySiteResourcesContact, MySiteResourcesContactTagged>(
  `MySiteResourcesContact`,
  (u: unknown): u is MySiteResourcesContact => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteResourcesContact> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteResourcesContact }))),
  (x: MySiteResourcesContact): MySiteResourcesContactTagged => ({ ...x, _tag: `MySiteResourcesContact`}),
)) satisfies t.Type<MySiteResourcesContact, unknown>;


export const mySiteSiteSettingsColorsAndHeaders = {
  _tag: `MySiteSiteSettingsColorsAndHeaders`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported168_issuerUser, imported188_issuerAdmin]
} as const;

export type MySiteSiteSettingsColorsAndHeadersTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteSiteSettingsColorsAndHeaders`>
}>;
export const mySiteSiteSettingsColorsAndHeadersTaggedC: MySiteSiteSettingsColorsAndHeadersTaggedC = t.type({
  _tag: t.literal(`MySiteSiteSettingsColorsAndHeaders`)
});
export type MySiteSiteSettingsColorsAndHeadersTagged = t.TypeOf<MySiteSiteSettingsColorsAndHeadersTaggedC>;
export type MySiteSiteSettingsColorsAndHeaders = MySiteSiteSettingsColorsAndHeadersTagged & typeof mySiteSiteSettingsColorsAndHeaders;
export type MySiteSiteSettingsColorsAndHeadersC = t.Type<MySiteSiteSettingsColorsAndHeaders, MySiteSiteSettingsColorsAndHeadersTagged>;
export const mySiteSiteSettingsColorsAndHeadersC: MySiteSiteSettingsColorsAndHeadersC = pipe(mySiteSiteSettingsColorsAndHeadersTaggedC, c => new t.Type<MySiteSiteSettingsColorsAndHeaders, MySiteSiteSettingsColorsAndHeadersTagged>(
  `MySiteSiteSettingsColorsAndHeaders`,
  (u: unknown): u is MySiteSiteSettingsColorsAndHeaders => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteSiteSettingsColorsAndHeaders> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteSiteSettingsColorsAndHeaders }))),
  (x: MySiteSiteSettingsColorsAndHeaders): MySiteSiteSettingsColorsAndHeadersTagged => ({ ...x, _tag: `MySiteSiteSettingsColorsAndHeaders`}),
)) satisfies t.Type<MySiteSiteSettingsColorsAndHeaders, unknown>;


export const mySiteSiteSettingsFooterAndMenu = {
  _tag: `MySiteSiteSettingsFooterAndMenu`,
  bankAllowed: false,
  featuresRequired: [imported2_menuItems],
  rolesAllowed: [imported170_issuerUser, imported190_issuerAdmin]
} as const;

export type MySiteSiteSettingsFooterAndMenuTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteSiteSettingsFooterAndMenu`>
}>;
export const mySiteSiteSettingsFooterAndMenuTaggedC: MySiteSiteSettingsFooterAndMenuTaggedC = t.type({
  _tag: t.literal(`MySiteSiteSettingsFooterAndMenu`)
});
export type MySiteSiteSettingsFooterAndMenuTagged = t.TypeOf<MySiteSiteSettingsFooterAndMenuTaggedC>;
export type MySiteSiteSettingsFooterAndMenu = MySiteSiteSettingsFooterAndMenuTagged & typeof mySiteSiteSettingsFooterAndMenu;
export type MySiteSiteSettingsFooterAndMenuC = t.Type<MySiteSiteSettingsFooterAndMenu, MySiteSiteSettingsFooterAndMenuTagged>;
export const mySiteSiteSettingsFooterAndMenuC: MySiteSiteSettingsFooterAndMenuC = pipe(mySiteSiteSettingsFooterAndMenuTaggedC, c => new t.Type<MySiteSiteSettingsFooterAndMenu, MySiteSiteSettingsFooterAndMenuTagged>(
  `MySiteSiteSettingsFooterAndMenu`,
  (u: unknown): u is MySiteSiteSettingsFooterAndMenu => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteSiteSettingsFooterAndMenu> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteSiteSettingsFooterAndMenu }))),
  (x: MySiteSiteSettingsFooterAndMenu): MySiteSiteSettingsFooterAndMenuTagged => ({ ...x, _tag: `MySiteSiteSettingsFooterAndMenu`}),
)) satisfies t.Type<MySiteSiteSettingsFooterAndMenu, unknown>;


export const mySiteSiteSettingsDisclaimers = {
  _tag: `MySiteSiteSettingsDisclaimers`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported172_issuerUser, imported192_issuerAdmin]
} as const;

export type MySiteSiteSettingsDisclaimersTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteSiteSettingsDisclaimers`>
}>;
export const mySiteSiteSettingsDisclaimersTaggedC: MySiteSiteSettingsDisclaimersTaggedC = t.type({
  _tag: t.literal(`MySiteSiteSettingsDisclaimers`)
});
export type MySiteSiteSettingsDisclaimersTagged = t.TypeOf<MySiteSiteSettingsDisclaimersTaggedC>;
export type MySiteSiteSettingsDisclaimers = MySiteSiteSettingsDisclaimersTagged & typeof mySiteSiteSettingsDisclaimers;
export type MySiteSiteSettingsDisclaimersC = t.Type<MySiteSiteSettingsDisclaimers, MySiteSiteSettingsDisclaimersTagged>;
export const mySiteSiteSettingsDisclaimersC: MySiteSiteSettingsDisclaimersC = pipe(mySiteSiteSettingsDisclaimersTaggedC, c => new t.Type<MySiteSiteSettingsDisclaimers, MySiteSiteSettingsDisclaimersTagged>(
  `MySiteSiteSettingsDisclaimers`,
  (u: unknown): u is MySiteSiteSettingsDisclaimers => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteSiteSettingsDisclaimers> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteSiteSettingsDisclaimers }))),
  (x: MySiteSiteSettingsDisclaimers): MySiteSiteSettingsDisclaimersTagged => ({ ...x, _tag: `MySiteSiteSettingsDisclaimers`}),
)) satisfies t.Type<MySiteSiteSettingsDisclaimers, unknown>;


export const mySiteSiteSettingsRelatedIssuers = {
  _tag: `MySiteSiteSettingsRelatedIssuers`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported174_issuerUser, imported194_issuerAdmin]
} as const;

export type MySiteSiteSettingsRelatedIssuersTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteSiteSettingsRelatedIssuers`>
}>;
export const mySiteSiteSettingsRelatedIssuersTaggedC: MySiteSiteSettingsRelatedIssuersTaggedC = t.type({
  _tag: t.literal(`MySiteSiteSettingsRelatedIssuers`)
});
export type MySiteSiteSettingsRelatedIssuersTagged = t.TypeOf<MySiteSiteSettingsRelatedIssuersTaggedC>;
export type MySiteSiteSettingsRelatedIssuers = MySiteSiteSettingsRelatedIssuersTagged & typeof mySiteSiteSettingsRelatedIssuers;
export type MySiteSiteSettingsRelatedIssuersC = t.Type<MySiteSiteSettingsRelatedIssuers, MySiteSiteSettingsRelatedIssuersTagged>;
export const mySiteSiteSettingsRelatedIssuersC: MySiteSiteSettingsRelatedIssuersC = pipe(mySiteSiteSettingsRelatedIssuersTaggedC, c => new t.Type<MySiteSiteSettingsRelatedIssuers, MySiteSiteSettingsRelatedIssuersTagged>(
  `MySiteSiteSettingsRelatedIssuers`,
  (u: unknown): u is MySiteSiteSettingsRelatedIssuers => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteSiteSettingsRelatedIssuers> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteSiteSettingsRelatedIssuers }))),
  (x: MySiteSiteSettingsRelatedIssuers): MySiteSiteSettingsRelatedIssuersTagged => ({ ...x, _tag: `MySiteSiteSettingsRelatedIssuers`}),
)) satisfies t.Type<MySiteSiteSettingsRelatedIssuers, unknown>;


export const mySiteSiteSettingsPageSetup = {
  _tag: `MySiteSiteSettingsPageSetup`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported176_issuerUser, imported196_issuerAdmin]
} as const;

export type MySiteSiteSettingsPageSetupTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteSiteSettingsPageSetup`>
}>;
export const mySiteSiteSettingsPageSetupTaggedC: MySiteSiteSettingsPageSetupTaggedC = t.type({
  _tag: t.literal(`MySiteSiteSettingsPageSetup`)
});
export type MySiteSiteSettingsPageSetupTagged = t.TypeOf<MySiteSiteSettingsPageSetupTaggedC>;
export type MySiteSiteSettingsPageSetup = MySiteSiteSettingsPageSetupTagged & typeof mySiteSiteSettingsPageSetup;
export type MySiteSiteSettingsPageSetupC = t.Type<MySiteSiteSettingsPageSetup, MySiteSiteSettingsPageSetupTagged>;
export const mySiteSiteSettingsPageSetupC: MySiteSiteSettingsPageSetupC = pipe(mySiteSiteSettingsPageSetupTaggedC, c => new t.Type<MySiteSiteSettingsPageSetup, MySiteSiteSettingsPageSetupTagged>(
  `MySiteSiteSettingsPageSetup`,
  (u: unknown): u is MySiteSiteSettingsPageSetup => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteSiteSettingsPageSetup> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteSiteSettingsPageSetup }))),
  (x: MySiteSiteSettingsPageSetup): MySiteSiteSettingsPageSetupTagged => ({ ...x, _tag: `MySiteSiteSettingsPageSetup`}),
)) satisfies t.Type<MySiteSiteSettingsPageSetup, unknown>;


export const tipsAndToolsPersonalizedTips = {
  _tag: `TipsAndToolsPersonalizedTips`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported178_issuerUser, imported198_issuerAdmin]
} as const;

export type TipsAndToolsPersonalizedTipsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`TipsAndToolsPersonalizedTips`>
}>;
export const tipsAndToolsPersonalizedTipsTaggedC: TipsAndToolsPersonalizedTipsTaggedC = t.type({
  _tag: t.literal(`TipsAndToolsPersonalizedTips`)
});
export type TipsAndToolsPersonalizedTipsTagged = t.TypeOf<TipsAndToolsPersonalizedTipsTaggedC>;
export type TipsAndToolsPersonalizedTips = TipsAndToolsPersonalizedTipsTagged & typeof tipsAndToolsPersonalizedTips;
export type TipsAndToolsPersonalizedTipsC = t.Type<TipsAndToolsPersonalizedTips, TipsAndToolsPersonalizedTipsTagged>;
export const tipsAndToolsPersonalizedTipsC: TipsAndToolsPersonalizedTipsC = pipe(tipsAndToolsPersonalizedTipsTaggedC, c => new t.Type<TipsAndToolsPersonalizedTips, TipsAndToolsPersonalizedTipsTagged>(
  `TipsAndToolsPersonalizedTips`,
  (u: unknown): u is TipsAndToolsPersonalizedTips => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, TipsAndToolsPersonalizedTips> => pipe(c.decode(u), E.map(x => ({ ...x, ...tipsAndToolsPersonalizedTips }))),
  (x: TipsAndToolsPersonalizedTips): TipsAndToolsPersonalizedTipsTagged => ({ ...x, _tag: `TipsAndToolsPersonalizedTips`}),
)) satisfies t.Type<TipsAndToolsPersonalizedTips, unknown>;


export const tipsAndToolsBestPractices = {
  _tag: `TipsAndToolsBestPractices`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported180_issuerUser, imported200_issuerAdmin]
} as const;

export type TipsAndToolsBestPracticesTaggedC = t.TypeC<{
  _tag: t.LiteralC<`TipsAndToolsBestPractices`>
}>;
export const tipsAndToolsBestPracticesTaggedC: TipsAndToolsBestPracticesTaggedC = t.type({
  _tag: t.literal(`TipsAndToolsBestPractices`)
});
export type TipsAndToolsBestPracticesTagged = t.TypeOf<TipsAndToolsBestPracticesTaggedC>;
export type TipsAndToolsBestPractices = TipsAndToolsBestPracticesTagged & typeof tipsAndToolsBestPractices;
export type TipsAndToolsBestPracticesC = t.Type<TipsAndToolsBestPractices, TipsAndToolsBestPracticesTagged>;
export const tipsAndToolsBestPracticesC: TipsAndToolsBestPracticesC = pipe(tipsAndToolsBestPracticesTaggedC, c => new t.Type<TipsAndToolsBestPractices, TipsAndToolsBestPracticesTagged>(
  `TipsAndToolsBestPractices`,
  (u: unknown): u is TipsAndToolsBestPractices => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, TipsAndToolsBestPractices> => pipe(c.decode(u), E.map(x => ({ ...x, ...tipsAndToolsBestPractices }))),
  (x: TipsAndToolsBestPractices): TipsAndToolsBestPracticesTagged => ({ ...x, _tag: `TipsAndToolsBestPractices`}),
)) satisfies t.Type<TipsAndToolsBestPractices, unknown>;


export const tipsAndToolsUserGuides = {
  _tag: `TipsAndToolsUserGuides`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported182_issuerUser, imported202_issuerAdmin]
} as const;

export type TipsAndToolsUserGuidesTaggedC = t.TypeC<{
  _tag: t.LiteralC<`TipsAndToolsUserGuides`>
}>;
export const tipsAndToolsUserGuidesTaggedC: TipsAndToolsUserGuidesTaggedC = t.type({
  _tag: t.literal(`TipsAndToolsUserGuides`)
});
export type TipsAndToolsUserGuidesTagged = t.TypeOf<TipsAndToolsUserGuidesTaggedC>;
export type TipsAndToolsUserGuides = TipsAndToolsUserGuidesTagged & typeof tipsAndToolsUserGuides;
export type TipsAndToolsUserGuidesC = t.Type<TipsAndToolsUserGuides, TipsAndToolsUserGuidesTagged>;
export const tipsAndToolsUserGuidesC: TipsAndToolsUserGuidesC = pipe(tipsAndToolsUserGuidesTaggedC, c => new t.Type<TipsAndToolsUserGuides, TipsAndToolsUserGuidesTagged>(
  `TipsAndToolsUserGuides`,
  (u: unknown): u is TipsAndToolsUserGuides => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, TipsAndToolsUserGuides> => pipe(c.decode(u), E.map(x => ({ ...x, ...tipsAndToolsUserGuides }))),
  (x: TipsAndToolsUserGuides): TipsAndToolsUserGuidesTagged => ({ ...x, _tag: `TipsAndToolsUserGuides`}),
)) satisfies t.Type<TipsAndToolsUserGuides, unknown>;


export const analyticsDocumentStatistics = {
  _tag: `AnalyticsDocumentStatistics`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported184_issuerUser, imported204_issuerAdmin]
} as const;

export type AnalyticsDocumentStatisticsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`AnalyticsDocumentStatistics`>
}>;
export const analyticsDocumentStatisticsTaggedC: AnalyticsDocumentStatisticsTaggedC = t.type({
  _tag: t.literal(`AnalyticsDocumentStatistics`)
});
export type AnalyticsDocumentStatisticsTagged = t.TypeOf<AnalyticsDocumentStatisticsTaggedC>;
export type AnalyticsDocumentStatistics = AnalyticsDocumentStatisticsTagged & typeof analyticsDocumentStatistics;
export type AnalyticsDocumentStatisticsC = t.Type<AnalyticsDocumentStatistics, AnalyticsDocumentStatisticsTagged>;
export const analyticsDocumentStatisticsC: AnalyticsDocumentStatisticsC = pipe(analyticsDocumentStatisticsTaggedC, c => new t.Type<AnalyticsDocumentStatistics, AnalyticsDocumentStatisticsTagged>(
  `AnalyticsDocumentStatistics`,
  (u: unknown): u is AnalyticsDocumentStatistics => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, AnalyticsDocumentStatistics> => pipe(c.decode(u), E.map(x => ({ ...x, ...analyticsDocumentStatistics }))),
  (x: AnalyticsDocumentStatistics): AnalyticsDocumentStatisticsTagged => ({ ...x, _tag: `AnalyticsDocumentStatistics`}),
)) satisfies t.Type<AnalyticsDocumentStatistics, unknown>;


export const analyticsDocumentActivity = {
  _tag: `AnalyticsDocumentActivity`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported186_issuerUser, imported206_issuerAdmin]
} as const;

export type AnalyticsDocumentActivityTaggedC = t.TypeC<{
  _tag: t.LiteralC<`AnalyticsDocumentActivity`>
}>;
export const analyticsDocumentActivityTaggedC: AnalyticsDocumentActivityTaggedC = t.type({
  _tag: t.literal(`AnalyticsDocumentActivity`)
});
export type AnalyticsDocumentActivityTagged = t.TypeOf<AnalyticsDocumentActivityTaggedC>;
export type AnalyticsDocumentActivity = AnalyticsDocumentActivityTagged & typeof analyticsDocumentActivity;
export type AnalyticsDocumentActivityC = t.Type<AnalyticsDocumentActivity, AnalyticsDocumentActivityTagged>;
export const analyticsDocumentActivityC: AnalyticsDocumentActivityC = pipe(analyticsDocumentActivityTaggedC, c => new t.Type<AnalyticsDocumentActivity, AnalyticsDocumentActivityTagged>(
  `AnalyticsDocumentActivity`,
  (u: unknown): u is AnalyticsDocumentActivity => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, AnalyticsDocumentActivity> => pipe(c.decode(u), E.map(x => ({ ...x, ...analyticsDocumentActivity }))),
  (x: AnalyticsDocumentActivity): AnalyticsDocumentActivityTagged => ({ ...x, _tag: `AnalyticsDocumentActivity`}),
)) satisfies t.Type<AnalyticsDocumentActivity, unknown>;


export const analyticsUserProfile = {
  _tag: `AnalyticsUserProfile`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported188_issuerUser, imported208_issuerAdmin]
} as const;

export type AnalyticsUserProfileTaggedC = t.TypeC<{
  _tag: t.LiteralC<`AnalyticsUserProfile`>
}>;
export const analyticsUserProfileTaggedC: AnalyticsUserProfileTaggedC = t.type({
  _tag: t.literal(`AnalyticsUserProfile`)
});
export type AnalyticsUserProfileTagged = t.TypeOf<AnalyticsUserProfileTaggedC>;
export type AnalyticsUserProfile = AnalyticsUserProfileTagged & typeof analyticsUserProfile;
export type AnalyticsUserProfileC = t.Type<AnalyticsUserProfile, AnalyticsUserProfileTagged>;
export const analyticsUserProfileC: AnalyticsUserProfileC = pipe(analyticsUserProfileTaggedC, c => new t.Type<AnalyticsUserProfile, AnalyticsUserProfileTagged>(
  `AnalyticsUserProfile`,
  (u: unknown): u is AnalyticsUserProfile => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, AnalyticsUserProfile> => pipe(c.decode(u), E.map(x => ({ ...x, ...analyticsUserProfile }))),
  (x: AnalyticsUserProfile): AnalyticsUserProfileTagged => ({ ...x, _tag: `AnalyticsUserProfile`}),
)) satisfies t.Type<AnalyticsUserProfile, unknown>;


export const analyticsEmailDetails = {
  _tag: `AnalyticsEmailDetails`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported190_issuerUser, imported210_issuerAdmin]
} as const;

export type AnalyticsEmailDetailsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`AnalyticsEmailDetails`>
}>;
export const analyticsEmailDetailsTaggedC: AnalyticsEmailDetailsTaggedC = t.type({
  _tag: t.literal(`AnalyticsEmailDetails`)
});
export type AnalyticsEmailDetailsTagged = t.TypeOf<AnalyticsEmailDetailsTaggedC>;
export type AnalyticsEmailDetails = AnalyticsEmailDetailsTagged & typeof analyticsEmailDetails;
export type AnalyticsEmailDetailsC = t.Type<AnalyticsEmailDetails, AnalyticsEmailDetailsTagged>;
export const analyticsEmailDetailsC: AnalyticsEmailDetailsC = pipe(analyticsEmailDetailsTaggedC, c => new t.Type<AnalyticsEmailDetails, AnalyticsEmailDetailsTagged>(
  `AnalyticsEmailDetails`,
  (u: unknown): u is AnalyticsEmailDetails => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, AnalyticsEmailDetails> => pipe(c.decode(u), E.map(x => ({ ...x, ...analyticsEmailDetails }))),
  (x: AnalyticsEmailDetails): AnalyticsEmailDetailsTagged => ({ ...x, _tag: `AnalyticsEmailDetails`}),
)) satisfies t.Type<AnalyticsEmailDetails, unknown>;


export const debtDataSeriesBreakdown = {
  _tag: `DebtDataSeriesBreakdown`,
  bankAllowed: true,
  featuresRequired: [imported32_debtProfile],
  rolesAllowed: [imported192_issuerUser, imported212_issuerAdmin]
} as const;

export type DebtDataSeriesBreakdownTaggedC = t.TypeC<{
  _tag: t.LiteralC<`DebtDataSeriesBreakdown`>
}>;
export const debtDataSeriesBreakdownTaggedC: DebtDataSeriesBreakdownTaggedC = t.type({
  _tag: t.literal(`DebtDataSeriesBreakdown`)
});
export type DebtDataSeriesBreakdownTagged = t.TypeOf<DebtDataSeriesBreakdownTaggedC>;
export type DebtDataSeriesBreakdown = DebtDataSeriesBreakdownTagged & typeof debtDataSeriesBreakdown;
export type DebtDataSeriesBreakdownC = t.Type<DebtDataSeriesBreakdown, DebtDataSeriesBreakdownTagged>;
export const debtDataSeriesBreakdownC: DebtDataSeriesBreakdownC = pipe(debtDataSeriesBreakdownTaggedC, c => new t.Type<DebtDataSeriesBreakdown, DebtDataSeriesBreakdownTagged>(
  `DebtDataSeriesBreakdown`,
  (u: unknown): u is DebtDataSeriesBreakdown => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, DebtDataSeriesBreakdown> => pipe(c.decode(u), E.map(x => ({ ...x, ...debtDataSeriesBreakdown }))),
  (x: DebtDataSeriesBreakdown): DebtDataSeriesBreakdownTagged => ({ ...x, _tag: `DebtDataSeriesBreakdown`}),
)) satisfies t.Type<DebtDataSeriesBreakdown, unknown>;


export const debtDataCustomSeriesBreakdown = {
  _tag: `DebtDataCustomSeriesBreakdown`,
  bankAllowed: true,
  featuresRequired: [imported34_debtProfile],
  rolesAllowed: [imported194_issuerUser, imported214_issuerAdmin]
} as const;

export type DebtDataCustomSeriesBreakdownTaggedC = t.TypeC<{
  _tag: t.LiteralC<`DebtDataCustomSeriesBreakdown`>
}>;
export const debtDataCustomSeriesBreakdownTaggedC: DebtDataCustomSeriesBreakdownTaggedC = t.type({
  _tag: t.literal(`DebtDataCustomSeriesBreakdown`)
});
export type DebtDataCustomSeriesBreakdownTagged = t.TypeOf<DebtDataCustomSeriesBreakdownTaggedC>;
export type DebtDataCustomSeriesBreakdown = DebtDataCustomSeriesBreakdownTagged & typeof debtDataCustomSeriesBreakdown;
export type DebtDataCustomSeriesBreakdownC = t.Type<DebtDataCustomSeriesBreakdown, DebtDataCustomSeriesBreakdownTagged>;
export const debtDataCustomSeriesBreakdownC: DebtDataCustomSeriesBreakdownC = pipe(debtDataCustomSeriesBreakdownTaggedC, c => new t.Type<DebtDataCustomSeriesBreakdown, DebtDataCustomSeriesBreakdownTagged>(
  `DebtDataCustomSeriesBreakdown`,
  (u: unknown): u is DebtDataCustomSeriesBreakdown => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, DebtDataCustomSeriesBreakdown> => pipe(c.decode(u), E.map(x => ({ ...x, ...debtDataCustomSeriesBreakdown }))),
  (x: DebtDataCustomSeriesBreakdown): DebtDataCustomSeriesBreakdownTagged => ({ ...x, _tag: `DebtDataCustomSeriesBreakdown`}),
)) satisfies t.Type<DebtDataCustomSeriesBreakdown, unknown>;


export const debtDataYearlyBreakdown = {
  _tag: `DebtDataYearlyBreakdown`,
  bankAllowed: true,
  featuresRequired: [imported36_debtProfile],
  rolesAllowed: [imported196_issuerUser, imported216_issuerAdmin]
} as const;

export type DebtDataYearlyBreakdownTaggedC = t.TypeC<{
  _tag: t.LiteralC<`DebtDataYearlyBreakdown`>
}>;
export const debtDataYearlyBreakdownTaggedC: DebtDataYearlyBreakdownTaggedC = t.type({
  _tag: t.literal(`DebtDataYearlyBreakdown`)
});
export type DebtDataYearlyBreakdownTagged = t.TypeOf<DebtDataYearlyBreakdownTaggedC>;
export type DebtDataYearlyBreakdown = DebtDataYearlyBreakdownTagged & typeof debtDataYearlyBreakdown;
export type DebtDataYearlyBreakdownC = t.Type<DebtDataYearlyBreakdown, DebtDataYearlyBreakdownTagged>;
export const debtDataYearlyBreakdownC: DebtDataYearlyBreakdownC = pipe(debtDataYearlyBreakdownTaggedC, c => new t.Type<DebtDataYearlyBreakdown, DebtDataYearlyBreakdownTagged>(
  `DebtDataYearlyBreakdown`,
  (u: unknown): u is DebtDataYearlyBreakdown => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, DebtDataYearlyBreakdown> => pipe(c.decode(u), E.map(x => ({ ...x, ...debtDataYearlyBreakdown }))),
  (x: DebtDataYearlyBreakdown): DebtDataYearlyBreakdownTagged => ({ ...x, _tag: `DebtDataYearlyBreakdown`}),
)) satisfies t.Type<DebtDataYearlyBreakdown, unknown>;


export const debtDataDataManagementCusip6 = {
  _tag: `DebtDataDataManagementCusip6`,
  bankAllowed: true,
  featuresRequired: [imported38_debtProfile],
  rolesAllowed: [imported198_issuerUser, imported218_issuerAdmin]
} as const;

export type DebtDataDataManagementCusip6TaggedC = t.TypeC<{
  _tag: t.LiteralC<`DebtDataDataManagementCusip6`>
}>;
export const debtDataDataManagementCusip6TaggedC: DebtDataDataManagementCusip6TaggedC = t.type({
  _tag: t.literal(`DebtDataDataManagementCusip6`)
});
export type DebtDataDataManagementCusip6Tagged = t.TypeOf<DebtDataDataManagementCusip6TaggedC>;
export type DebtDataDataManagementCusip6 = DebtDataDataManagementCusip6Tagged & typeof debtDataDataManagementCusip6;
export type DebtDataDataManagementCusip6C = t.Type<DebtDataDataManagementCusip6, DebtDataDataManagementCusip6Tagged>;
export const debtDataDataManagementCusip6C: DebtDataDataManagementCusip6C = pipe(debtDataDataManagementCusip6TaggedC, c => new t.Type<DebtDataDataManagementCusip6, DebtDataDataManagementCusip6Tagged>(
  `DebtDataDataManagementCusip6`,
  (u: unknown): u is DebtDataDataManagementCusip6 => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, DebtDataDataManagementCusip6> => pipe(c.decode(u), E.map(x => ({ ...x, ...debtDataDataManagementCusip6 }))),
  (x: DebtDataDataManagementCusip6): DebtDataDataManagementCusip6Tagged => ({ ...x, _tag: `DebtDataDataManagementCusip6`}),
)) satisfies t.Type<DebtDataDataManagementCusip6, unknown>;


export const debtDataDataManagementSeries = {
  _tag: `DebtDataDataManagementSeries`,
  bankAllowed: true,
  featuresRequired: [imported40_debtProfile],
  rolesAllowed: [imported200_issuerUser, imported220_issuerAdmin]
} as const;

export type DebtDataDataManagementSeriesTaggedC = t.TypeC<{
  _tag: t.LiteralC<`DebtDataDataManagementSeries`>
}>;
export const debtDataDataManagementSeriesTaggedC: DebtDataDataManagementSeriesTaggedC = t.type({
  _tag: t.literal(`DebtDataDataManagementSeries`)
});
export type DebtDataDataManagementSeriesTagged = t.TypeOf<DebtDataDataManagementSeriesTaggedC>;
export type DebtDataDataManagementSeries = DebtDataDataManagementSeriesTagged & typeof debtDataDataManagementSeries;
export type DebtDataDataManagementSeriesC = t.Type<DebtDataDataManagementSeries, DebtDataDataManagementSeriesTagged>;
export const debtDataDataManagementSeriesC: DebtDataDataManagementSeriesC = pipe(debtDataDataManagementSeriesTaggedC, c => new t.Type<DebtDataDataManagementSeries, DebtDataDataManagementSeriesTagged>(
  `DebtDataDataManagementSeries`,
  (u: unknown): u is DebtDataDataManagementSeries => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, DebtDataDataManagementSeries> => pipe(c.decode(u), E.map(x => ({ ...x, ...debtDataDataManagementSeries }))),
  (x: DebtDataDataManagementSeries): DebtDataDataManagementSeriesTagged => ({ ...x, _tag: `DebtDataDataManagementSeries`}),
)) satisfies t.Type<DebtDataDataManagementSeries, unknown>;


export const debtDataDataManagementCustomSeries = {
  _tag: `DebtDataDataManagementCustomSeries`,
  bankAllowed: true,
  featuresRequired: [imported42_debtProfile],
  rolesAllowed: [imported202_issuerUser, imported222_issuerAdmin]
} as const;

export type DebtDataDataManagementCustomSeriesTaggedC = t.TypeC<{
  _tag: t.LiteralC<`DebtDataDataManagementCustomSeries`>
}>;
export const debtDataDataManagementCustomSeriesTaggedC: DebtDataDataManagementCustomSeriesTaggedC = t.type({
  _tag: t.literal(`DebtDataDataManagementCustomSeries`)
});
export type DebtDataDataManagementCustomSeriesTagged = t.TypeOf<DebtDataDataManagementCustomSeriesTaggedC>;
export type DebtDataDataManagementCustomSeries = DebtDataDataManagementCustomSeriesTagged & typeof debtDataDataManagementCustomSeries;
export type DebtDataDataManagementCustomSeriesC = t.Type<DebtDataDataManagementCustomSeries, DebtDataDataManagementCustomSeriesTagged>;
export const debtDataDataManagementCustomSeriesC: DebtDataDataManagementCustomSeriesC = pipe(debtDataDataManagementCustomSeriesTaggedC, c => new t.Type<DebtDataDataManagementCustomSeries, DebtDataDataManagementCustomSeriesTagged>(
  `DebtDataDataManagementCustomSeries`,
  (u: unknown): u is DebtDataDataManagementCustomSeries => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, DebtDataDataManagementCustomSeries> => pipe(c.decode(u), E.map(x => ({ ...x, ...debtDataDataManagementCustomSeries }))),
  (x: DebtDataDataManagementCustomSeries): DebtDataDataManagementCustomSeriesTagged => ({ ...x, _tag: `DebtDataDataManagementCustomSeries`}),
)) satisfies t.Type<DebtDataDataManagementCustomSeries, unknown>;


export const debtDataReviewDetails = {
  _tag: `DebtDataReviewDetails`,
  bankAllowed: true,
  featuresRequired: [imported44_debtProfile],
  rolesAllowed: [imported224_issuerAdmin]
} as const;

export type DebtDataReviewDetailsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`DebtDataReviewDetails`>
}>;
export const debtDataReviewDetailsTaggedC: DebtDataReviewDetailsTaggedC = t.type({
  _tag: t.literal(`DebtDataReviewDetails`)
});
export type DebtDataReviewDetailsTagged = t.TypeOf<DebtDataReviewDetailsTaggedC>;
export type DebtDataReviewDetails = DebtDataReviewDetailsTagged & typeof debtDataReviewDetails;
export type DebtDataReviewDetailsC = t.Type<DebtDataReviewDetails, DebtDataReviewDetailsTagged>;
export const debtDataReviewDetailsC: DebtDataReviewDetailsC = pipe(debtDataReviewDetailsTaggedC, c => new t.Type<DebtDataReviewDetails, DebtDataReviewDetailsTagged>(
  `DebtDataReviewDetails`,
  (u: unknown): u is DebtDataReviewDetails => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, DebtDataReviewDetails> => pipe(c.decode(u), E.map(x => ({ ...x, ...debtDataReviewDetails }))),
  (x: DebtDataReviewDetails): DebtDataReviewDetailsTagged => ({ ...x, _tag: `DebtDataReviewDetails`}),
)) satisfies t.Type<DebtDataReviewDetails, unknown>;


export const debtDataTagSettings = {
  _tag: `DebtDataTagSettings`,
  bankAllowed: true,
  featuresRequired: [imported46_debtProfile],
  rolesAllowed: [imported204_issuerUser, imported226_issuerAdmin]
} as const;

export type DebtDataTagSettingsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`DebtDataTagSettings`>
}>;
export const debtDataTagSettingsTaggedC: DebtDataTagSettingsTaggedC = t.type({
  _tag: t.literal(`DebtDataTagSettings`)
});
export type DebtDataTagSettingsTagged = t.TypeOf<DebtDataTagSettingsTaggedC>;
export type DebtDataTagSettings = DebtDataTagSettingsTagged & typeof debtDataTagSettings;
export type DebtDataTagSettingsC = t.Type<DebtDataTagSettings, DebtDataTagSettingsTagged>;
export const debtDataTagSettingsC: DebtDataTagSettingsC = pipe(debtDataTagSettingsTaggedC, c => new t.Type<DebtDataTagSettings, DebtDataTagSettingsTagged>(
  `DebtDataTagSettings`,
  (u: unknown): u is DebtDataTagSettings => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, DebtDataTagSettings> => pipe(c.decode(u), E.map(x => ({ ...x, ...debtDataTagSettings }))),
  (x: DebtDataTagSettings): DebtDataTagSettingsTagged => ({ ...x, _tag: `DebtDataTagSettings`}),
)) satisfies t.Type<DebtDataTagSettings, unknown>;


export const marketInsightsArticle = {
  _tag: `MarketInsightsArticle`,
  bankAllowed: true,
  featuresRequired: [],
  rolesAllowed: [imported206_issuerUser, imported228_issuerAdmin]
} as const;

export type MarketInsightsArticleTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MarketInsightsArticle`>
}>;
export const marketInsightsArticleTaggedC: MarketInsightsArticleTaggedC = t.type({
  _tag: t.literal(`MarketInsightsArticle`)
});
export type MarketInsightsArticleTagged = t.TypeOf<MarketInsightsArticleTaggedC>;
export type MarketInsightsArticle = MarketInsightsArticleTagged & typeof marketInsightsArticle;
export type MarketInsightsArticleC = t.Type<MarketInsightsArticle, MarketInsightsArticleTagged>;
export const marketInsightsArticleC: MarketInsightsArticleC = pipe(marketInsightsArticleTaggedC, c => new t.Type<MarketInsightsArticle, MarketInsightsArticleTagged>(
  `MarketInsightsArticle`,
  (u: unknown): u is MarketInsightsArticle => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MarketInsightsArticle> => pipe(c.decode(u), E.map(x => ({ ...x, ...marketInsightsArticle }))),
  (x: MarketInsightsArticle): MarketInsightsArticleTagged => ({ ...x, _tag: `MarketInsightsArticle`}),
)) satisfies t.Type<MarketInsightsArticle, unknown>;


export const mySiteBondsRfpsBids = {
  _tag: `MySiteBondsRfpsBids`,
  bankAllowed: false,
  featuresRequired: [],
  rolesAllowed: [imported208_issuerUser, imported230_issuerAdmin]
} as const;

export type MySiteBondsRfpsBidsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`MySiteBondsRfpsBids`>
}>;
export const mySiteBondsRfpsBidsTaggedC: MySiteBondsRfpsBidsTaggedC = t.type({
  _tag: t.literal(`MySiteBondsRfpsBids`)
});
export type MySiteBondsRfpsBidsTagged = t.TypeOf<MySiteBondsRfpsBidsTaggedC>;
export type MySiteBondsRfpsBids = MySiteBondsRfpsBidsTagged & typeof mySiteBondsRfpsBids;
export type MySiteBondsRfpsBidsC = t.Type<MySiteBondsRfpsBids, MySiteBondsRfpsBidsTagged>;
export const mySiteBondsRfpsBidsC: MySiteBondsRfpsBidsC = pipe(mySiteBondsRfpsBidsTaggedC, c => new t.Type<MySiteBondsRfpsBids, MySiteBondsRfpsBidsTagged>(
  `MySiteBondsRfpsBids`,
  (u: unknown): u is MySiteBondsRfpsBids => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, MySiteBondsRfpsBids> => pipe(c.decode(u), E.map(x => ({ ...x, ...mySiteBondsRfpsBids }))),
  (x: MySiteBondsRfpsBids): MySiteBondsRfpsBidsTagged => ({ ...x, _tag: `MySiteBondsRfpsBids`}),
)) satisfies t.Type<MySiteBondsRfpsBids, unknown>;


export const allIssuerPortalPageC = [adminSettingsC, adminUsersC, adminInvoicesC, analyticsSiteActivityC, analyticsUserActivityC, analyticsCustomReportsC, analyticsEmailsC, dashboardC, debtDataDebtProfileC, debtDataDataManagementC, debtDataReviewCenterC, debtDataSettingsC, marketInsightsC, mySiteAboutC, mySiteAboutEsgProgramC, mySiteAboutNewsAndEventsC, mySiteAboutProjectsC, mySiteAboutTeamC, mySiteBondsC, mySiteBondsParticipantsC, mySiteBondsRatingsC, mySiteBondsRoadshowsC, mySiteBondsRfpsC, mySiteBondsProgramsC, mySiteChangeApprovalC, mySiteCustomPagesC, mySiteDocumentsC, mySiteDocumentsCategoriesC, mySiteDocumentsIrmaLetterC, mySiteHomeC, mySiteResourcesCusip9sC, mySiteResourcesCusip6sC, mySiteResourcesFaqsC, mySiteResourcesLinksC, mySiteResourcesContactC, mySiteSiteSettingsColorsAndHeadersC, mySiteSiteSettingsFooterAndMenuC, mySiteSiteSettingsDisclaimersC, mySiteSiteSettingsRelatedIssuersC, mySiteSiteSettingsPageSetupC, tipsAndToolsPersonalizedTipsC, tipsAndToolsBestPracticesC, tipsAndToolsUserGuidesC, analyticsDocumentStatisticsC, analyticsDocumentActivityC, analyticsUserProfileC, analyticsEmailDetailsC, debtDataSeriesBreakdownC, debtDataCustomSeriesBreakdownC, debtDataYearlyBreakdownC, debtDataDataManagementCusip6C, debtDataDataManagementSeriesC, debtDataDataManagementCustomSeriesC, debtDataReviewDetailsC, debtDataTagSettingsC, marketInsightsArticleC, mySiteBondsRfpsBidsC] as const;
export const allIssuerPortalPageNames = [`AdminSettings`, `AdminUsers`, `AdminInvoices`, `AnalyticsSiteActivity`, `AnalyticsUserActivity`, `AnalyticsCustomReports`, `AnalyticsEmails`, `Dashboard`, `DebtDataDebtProfile`, `DebtDataDataManagement`, `DebtDataReviewCenter`, `DebtDataSettings`, `MarketInsights`, `MySiteAbout`, `MySiteAboutEsgProgram`, `MySiteAboutNewsAndEvents`, `MySiteAboutProjects`, `MySiteAboutTeam`, `MySiteBonds`, `MySiteBondsParticipants`, `MySiteBondsRatings`, `MySiteBondsRoadshows`, `MySiteBondsRfps`, `MySiteBondsPrograms`, `MySiteChangeApproval`, `MySiteCustomPages`, `MySiteDocuments`, `MySiteDocumentsCategories`, `MySiteDocumentsIrmaLetter`, `MySiteHome`, `MySiteResourcesCusip9s`, `MySiteResourcesCusip6s`, `MySiteResourcesFaqs`, `MySiteResourcesLinks`, `MySiteResourcesContact`, `MySiteSiteSettingsColorsAndHeaders`, `MySiteSiteSettingsFooterAndMenu`, `MySiteSiteSettingsDisclaimers`, `MySiteSiteSettingsRelatedIssuers`, `MySiteSiteSettingsPageSetup`, `TipsAndToolsPersonalizedTips`, `TipsAndToolsBestPractices`, `TipsAndToolsUserGuides`, `AnalyticsDocumentStatistics`, `AnalyticsDocumentActivity`, `AnalyticsUserProfile`, `AnalyticsEmailDetails`, `DebtDataSeriesBreakdown`, `DebtDataCustomSeriesBreakdown`, `DebtDataYearlyBreakdown`, `DebtDataDataManagementCusip6`, `DebtDataDataManagementSeries`, `DebtDataDataManagementCustomSeries`, `DebtDataReviewDetails`, `DebtDataTagSettings`, `MarketInsightsArticle`, `MySiteBondsRfpsBids`] as const;
export type IssuerPortalPageName = (typeof allIssuerPortalPageNames)[number];

export type IssuerPortalPageCU = t.UnionC<[AdminSettingsC, AdminUsersC, AdminInvoicesC, AnalyticsSiteActivityC, AnalyticsUserActivityC, AnalyticsCustomReportsC, AnalyticsEmailsC, DashboardC, DebtDataDebtProfileC, DebtDataDataManagementC, DebtDataReviewCenterC, DebtDataSettingsC, MarketInsightsC, MySiteAboutC, MySiteAboutEsgProgramC, MySiteAboutNewsAndEventsC, MySiteAboutProjectsC, MySiteAboutTeamC, MySiteBondsC, MySiteBondsParticipantsC, MySiteBondsRatingsC, MySiteBondsRoadshowsC, MySiteBondsRfpsC, MySiteBondsProgramsC, MySiteChangeApprovalC, MySiteCustomPagesC, MySiteDocumentsC, MySiteDocumentsCategoriesC, MySiteDocumentsIrmaLetterC, MySiteHomeC, MySiteResourcesCusip9sC, MySiteResourcesCusip6sC, MySiteResourcesFaqsC, MySiteResourcesLinksC, MySiteResourcesContactC, MySiteSiteSettingsColorsAndHeadersC, MySiteSiteSettingsFooterAndMenuC, MySiteSiteSettingsDisclaimersC, MySiteSiteSettingsRelatedIssuersC, MySiteSiteSettingsPageSetupC, TipsAndToolsPersonalizedTipsC, TipsAndToolsBestPracticesC, TipsAndToolsUserGuidesC, AnalyticsDocumentStatisticsC, AnalyticsDocumentActivityC, AnalyticsUserProfileC, AnalyticsEmailDetailsC, DebtDataSeriesBreakdownC, DebtDataCustomSeriesBreakdownC, DebtDataYearlyBreakdownC, DebtDataDataManagementCusip6C, DebtDataDataManagementSeriesC, DebtDataDataManagementCustomSeriesC, DebtDataReviewDetailsC, DebtDataTagSettingsC, MarketInsightsArticleC, MySiteBondsRfpsBidsC]>;
export type IssuerPortalPageU = AdminSettings | AdminUsers | AdminInvoices | AnalyticsSiteActivity | AnalyticsUserActivity | AnalyticsCustomReports | AnalyticsEmails | Dashboard | DebtDataDebtProfile | DebtDataDataManagement | DebtDataReviewCenter | DebtDataSettings | MarketInsights | MySiteAbout | MySiteAboutEsgProgram | MySiteAboutNewsAndEvents | MySiteAboutProjects | MySiteAboutTeam | MySiteBonds | MySiteBondsParticipants | MySiteBondsRatings | MySiteBondsRoadshows | MySiteBondsRfps | MySiteBondsPrograms | MySiteChangeApproval | MySiteCustomPages | MySiteDocuments | MySiteDocumentsCategories | MySiteDocumentsIrmaLetter | MySiteHome | MySiteResourcesCusip9s | MySiteResourcesCusip6s | MySiteResourcesFaqs | MySiteResourcesLinks | MySiteResourcesContact | MySiteSiteSettingsColorsAndHeaders | MySiteSiteSettingsFooterAndMenu | MySiteSiteSettingsDisclaimers | MySiteSiteSettingsRelatedIssuers | MySiteSiteSettingsPageSetup | TipsAndToolsPersonalizedTips | TipsAndToolsBestPractices | TipsAndToolsUserGuides | AnalyticsDocumentStatistics | AnalyticsDocumentActivity | AnalyticsUserProfile | AnalyticsEmailDetails | DebtDataSeriesBreakdown | DebtDataCustomSeriesBreakdown | DebtDataYearlyBreakdown | DebtDataDataManagementCusip6 | DebtDataDataManagementSeries | DebtDataDataManagementCustomSeries | DebtDataReviewDetails | DebtDataTagSettings | MarketInsightsArticle | MySiteBondsRfpsBids;
export const IssuerPortalPageCU: IssuerPortalPageCU = t.union([adminSettingsC, adminUsersC, adminInvoicesC, analyticsSiteActivityC, analyticsUserActivityC, analyticsCustomReportsC, analyticsEmailsC, dashboardC, debtDataDebtProfileC, debtDataDataManagementC, debtDataReviewCenterC, debtDataSettingsC, marketInsightsC, mySiteAboutC, mySiteAboutEsgProgramC, mySiteAboutNewsAndEventsC, mySiteAboutProjectsC, mySiteAboutTeamC, mySiteBondsC, mySiteBondsParticipantsC, mySiteBondsRatingsC, mySiteBondsRoadshowsC, mySiteBondsRfpsC, mySiteBondsProgramsC, mySiteChangeApprovalC, mySiteCustomPagesC, mySiteDocumentsC, mySiteDocumentsCategoriesC, mySiteDocumentsIrmaLetterC, mySiteHomeC, mySiteResourcesCusip9sC, mySiteResourcesCusip6sC, mySiteResourcesFaqsC, mySiteResourcesLinksC, mySiteResourcesContactC, mySiteSiteSettingsColorsAndHeadersC, mySiteSiteSettingsFooterAndMenuC, mySiteSiteSettingsDisclaimersC, mySiteSiteSettingsRelatedIssuersC, mySiteSiteSettingsPageSetupC, tipsAndToolsPersonalizedTipsC, tipsAndToolsBestPracticesC, tipsAndToolsUserGuidesC, analyticsDocumentStatisticsC, analyticsDocumentActivityC, analyticsUserProfileC, analyticsEmailDetailsC, debtDataSeriesBreakdownC, debtDataCustomSeriesBreakdownC, debtDataYearlyBreakdownC, debtDataDataManagementCusip6C, debtDataDataManagementSeriesC, debtDataDataManagementCustomSeriesC, debtDataReviewDetailsC, debtDataTagSettingsC, marketInsightsArticleC, mySiteBondsRfpsBidsC]) satisfies t.Type<IssuerPortalPageU, unknown>;

export const issuerPortalPageOrd: Ord.Ord<IssuerPortalPageU> = pipe(stringOrd, Ord.contramap(x => x._tag));
export const allIssuerPortalPage = [adminSettings, adminUsers, adminInvoices, analyticsSiteActivity, analyticsUserActivity, analyticsCustomReports, analyticsEmails, dashboard, debtDataDebtProfile, debtDataDataManagement, debtDataReviewCenter, debtDataSettings, marketInsights, mySiteAbout, mySiteAboutEsgProgram, mySiteAboutNewsAndEvents, mySiteAboutProjects, mySiteAboutTeam, mySiteBonds, mySiteBondsParticipants, mySiteBondsRatings, mySiteBondsRoadshows, mySiteBondsRfps, mySiteBondsPrograms, mySiteChangeApproval, mySiteCustomPages, mySiteDocuments, mySiteDocumentsCategories, mySiteDocumentsIrmaLetter, mySiteHome, mySiteResourcesCusip9s, mySiteResourcesCusip6s, mySiteResourcesFaqs, mySiteResourcesLinks, mySiteResourcesContact, mySiteSiteSettingsColorsAndHeaders, mySiteSiteSettingsFooterAndMenu, mySiteSiteSettingsDisclaimers, mySiteSiteSettingsRelatedIssuers, mySiteSiteSettingsPageSetup, tipsAndToolsPersonalizedTips, tipsAndToolsBestPractices, tipsAndToolsUserGuides, analyticsDocumentStatistics, analyticsDocumentActivity, analyticsUserProfile, analyticsEmailDetails, debtDataSeriesBreakdown, debtDataCustomSeriesBreakdown, debtDataYearlyBreakdown, debtDataDataManagementCusip6, debtDataDataManagementSeries, debtDataDataManagementCustomSeries, debtDataReviewDetails, debtDataTagSettings, marketInsightsArticle, mySiteBondsRfpsBids] as const;
export type IssuerPortalPageMap<A> = { [K in IssuerPortalPageName]: A };





const adminInvoicesPath = lit("issuer-portal").then(lit("admin")).then(lit("invoices"));
const adminInvoicesPathParts = ["admin", "invoices"] as const;
export type AdminInvoicesPathParts = typeof adminInvoicesPathParts;

const adminInvoicesQuery = t.strict({});
export type AdminInvoicesParams = Describe<typeof adminInvoicesPath._A & typeof adminInvoicesQuery._A>;

export type AdminInvoicesRoute<A = {}> = { match: Match<AdminInvoicesParams & A>; pathParts: AdminInvoicesPathParts };

export function adminInvoicesRoute(): AdminInvoicesRoute;
export function adminInvoicesRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, AdminInvoicesParams>): AdminInvoicesRoute<t.TypeOf<A>>;
export function adminInvoicesRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, AdminInvoicesParams>) {
  return {
    match: (q ? adminInvoicesPath.then(query(t.intersection([adminInvoicesQuery, q]))) : adminInvoicesPath.then(query(adminInvoicesQuery))).then(end),
    pathParts: adminInvoicesPathParts,
  };
}

const adminSettingsPath = lit("issuer-portal").then(lit("admin")).then(lit("settings"));
const adminSettingsPathParts = ["admin", "settings"] as const;
export type AdminSettingsPathParts = typeof adminSettingsPathParts;

const adminSettingsQuery = t.strict({});
export type AdminSettingsParams = Describe<typeof adminSettingsPath._A & typeof adminSettingsQuery._A>;

export type AdminSettingsRoute<A = {}> = { match: Match<AdminSettingsParams & A>; pathParts: AdminSettingsPathParts };

export function adminSettingsRoute(): AdminSettingsRoute;
export function adminSettingsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, AdminSettingsParams>): AdminSettingsRoute<t.TypeOf<A>>;
export function adminSettingsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, AdminSettingsParams>) {
  return {
    match: (q ? adminSettingsPath.then(query(t.intersection([adminSettingsQuery, q]))) : adminSettingsPath.then(query(adminSettingsQuery))).then(end),
    pathParts: adminSettingsPathParts,
  };
}

const adminUsersPath = lit("issuer-portal").then(lit("admin")).then(lit("users"));
const adminUsersPathParts = ["admin", "users"] as const;
export type AdminUsersPathParts = typeof adminUsersPathParts;

const adminUsersQuery = t.strict({});
export type AdminUsersParams = Describe<typeof adminUsersPath._A & typeof adminUsersQuery._A>;

export type AdminUsersRoute<A = {}> = { match: Match<AdminUsersParams & A>; pathParts: AdminUsersPathParts };

export function adminUsersRoute(): AdminUsersRoute;
export function adminUsersRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, AdminUsersParams>): AdminUsersRoute<t.TypeOf<A>>;
export function adminUsersRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, AdminUsersParams>) {
  return {
    match: (q ? adminUsersPath.then(query(t.intersection([adminUsersQuery, q]))) : adminUsersPath.then(query(adminUsersQuery))).then(end),
    pathParts: adminUsersPathParts,
  };
}

const analyticsCustomReportsPath = lit("issuer-portal").then(lit("analytics")).then(lit("custom-reports"));
const analyticsCustomReportsPathParts = ["analytics", "custom-reports"] as const;
export type AnalyticsCustomReportsPathParts = typeof analyticsCustomReportsPathParts;

const analyticsCustomReportsQuery = t.strict({});
export type AnalyticsCustomReportsParams = Describe<typeof analyticsCustomReportsPath._A & typeof analyticsCustomReportsQuery._A>;

export type AnalyticsCustomReportsRoute<A = {}> = { match: Match<AnalyticsCustomReportsParams & A>; pathParts: AnalyticsCustomReportsPathParts };

export function analyticsCustomReportsRoute(): AnalyticsCustomReportsRoute;
export function analyticsCustomReportsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, AnalyticsCustomReportsParams>): AnalyticsCustomReportsRoute<t.TypeOf<A>>;
export function analyticsCustomReportsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, AnalyticsCustomReportsParams>) {
  return {
    match: (q ? analyticsCustomReportsPath.then(query(t.intersection([analyticsCustomReportsQuery, q]))) : analyticsCustomReportsPath.then(query(analyticsCustomReportsQuery))).then(end),
    pathParts: analyticsCustomReportsPathParts,
  };
}

const analyticsDocumentActivityPath = lit("issuer-portal").then(lit("analytics")).then(lit("document-statistics")).then(lit("document-activity")).then(int("id"));
const analyticsDocumentActivityPathParts = ["analytics", "document-statistics", "document-activity", "id"] as const;
export type AnalyticsDocumentActivityPathParts = typeof analyticsDocumentActivityPathParts;

const analyticsDocumentActivityQuery = t.exact(t.partial({
  "days": t.union([
    literalNumberFromString(1), literalNumberFromString(7), literalNumberFromString(30), literalNumberFromString(90), literalNumberFromString(365)
  ])
}));
export type AnalyticsDocumentActivityParamsRaw = Describe<typeof analyticsDocumentActivityPath._A & typeof analyticsDocumentActivityQuery._A>;
export type AnalyticsDocumentActivityParams = Describe<NullableToOptionalFields<AnalyticsDocumentActivityParamsRaw>>;

export type AnalyticsDocumentActivityRoute<A = {}> = { match: Match<AnalyticsDocumentActivityParamsRaw & A>; pathParts: AnalyticsDocumentActivityPathParts };

export function analyticsDocumentActivityRoute(): AnalyticsDocumentActivityRoute;
export function analyticsDocumentActivityRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, AnalyticsDocumentActivityParamsRaw>): AnalyticsDocumentActivityRoute<t.TypeOf<A>>;
export function analyticsDocumentActivityRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, AnalyticsDocumentActivityParamsRaw>) {
  return {
    match: (q ? analyticsDocumentActivityPath.then(query(t.intersection([analyticsDocumentActivityQuery, q]))) : analyticsDocumentActivityPath.then(query(analyticsDocumentActivityQuery))).then(end),
    pathParts: analyticsDocumentActivityPathParts,
  };
}

const analyticsDocumentStatisticsPath = lit("issuer-portal").then(lit("analytics")).then(lit("document-statistics"));
const analyticsDocumentStatisticsPathParts = ["analytics", "document-statistics"] as const;
export type AnalyticsDocumentStatisticsPathParts = typeof analyticsDocumentStatisticsPathParts;

const analyticsDocumentStatisticsQuery = t.exact(t.partial({
  "days": t.union([
    literalNumberFromString(1), literalNumberFromString(7), literalNumberFromString(30), literalNumberFromString(90), literalNumberFromString(365)
  ])
}));
export type AnalyticsDocumentStatisticsParamsRaw = Describe<typeof analyticsDocumentStatisticsPath._A & typeof analyticsDocumentStatisticsQuery._A>;
export type AnalyticsDocumentStatisticsParams = Describe<NullableToOptionalFields<AnalyticsDocumentStatisticsParamsRaw>>;

export type AnalyticsDocumentStatisticsRoute<A = {}> = { match: Match<AnalyticsDocumentStatisticsParamsRaw & A>; pathParts: AnalyticsDocumentStatisticsPathParts };

export function analyticsDocumentStatisticsRoute(): AnalyticsDocumentStatisticsRoute;
export function analyticsDocumentStatisticsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, AnalyticsDocumentStatisticsParamsRaw>): AnalyticsDocumentStatisticsRoute<t.TypeOf<A>>;
export function analyticsDocumentStatisticsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, AnalyticsDocumentStatisticsParamsRaw>) {
  return {
    match: (q ? analyticsDocumentStatisticsPath.then(query(t.intersection([analyticsDocumentStatisticsQuery, q]))) : analyticsDocumentStatisticsPath.then(query(analyticsDocumentStatisticsQuery))).then(end),
    pathParts: analyticsDocumentStatisticsPathParts,
  };
}

const analyticsEmailsPath = lit("issuer-portal").then(lit("analytics")).then(lit("emails"));
const analyticsEmailsPathParts = ["analytics", "emails"] as const;
export type AnalyticsEmailsPathParts = typeof analyticsEmailsPathParts;

const analyticsEmailsQuery = t.strict({});
export type AnalyticsEmailsParams = Describe<typeof analyticsEmailsPath._A & typeof analyticsEmailsQuery._A>;

export type AnalyticsEmailsRoute<A = {}> = { match: Match<AnalyticsEmailsParams & A>; pathParts: AnalyticsEmailsPathParts };

export function analyticsEmailsRoute(): AnalyticsEmailsRoute;
export function analyticsEmailsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, AnalyticsEmailsParams>): AnalyticsEmailsRoute<t.TypeOf<A>>;
export function analyticsEmailsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, AnalyticsEmailsParams>) {
  return {
    match: (q ? analyticsEmailsPath.then(query(t.intersection([analyticsEmailsQuery, q]))) : analyticsEmailsPath.then(query(analyticsEmailsQuery))).then(end),
    pathParts: analyticsEmailsPathParts,
  };
}

const analyticsEmailDetailsPath = lit("issuer-portal").then(lit("analytics")).then(lit("emails")).then(lit("details")).then(int("campaignId"));
const analyticsEmailDetailsPathParts = ["analytics", "emails", "details", "campaignId"] as const;
export type AnalyticsEmailDetailsPathParts = typeof analyticsEmailDetailsPathParts;

const analyticsEmailDetailsQuery = t.strict({});
export type AnalyticsEmailDetailsParams = Describe<typeof analyticsEmailDetailsPath._A & typeof analyticsEmailDetailsQuery._A>;

export type AnalyticsEmailDetailsRoute<A = {}> = { match: Match<AnalyticsEmailDetailsParams & A>; pathParts: AnalyticsEmailDetailsPathParts };

export function analyticsEmailDetailsRoute(): AnalyticsEmailDetailsRoute;
export function analyticsEmailDetailsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, AnalyticsEmailDetailsParams>): AnalyticsEmailDetailsRoute<t.TypeOf<A>>;
export function analyticsEmailDetailsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, AnalyticsEmailDetailsParams>) {
  return {
    match: (q ? analyticsEmailDetailsPath.then(query(t.intersection([analyticsEmailDetailsQuery, q]))) : analyticsEmailDetailsPath.then(query(analyticsEmailDetailsQuery))).then(end),
    pathParts: analyticsEmailDetailsPathParts,
  };
}

const analyticsSiteActivityPath = lit("issuer-portal").then(lit("analytics")).then(lit("site-activity"));
const analyticsSiteActivityPathParts = ["analytics", "site-activity"] as const;
export type AnalyticsSiteActivityPathParts = typeof analyticsSiteActivityPathParts;

const analyticsSiteActivityQuery = t.strict({});
export type AnalyticsSiteActivityParams = Describe<typeof analyticsSiteActivityPath._A & typeof analyticsSiteActivityQuery._A>;

export type AnalyticsSiteActivityRoute<A = {}> = { match: Match<AnalyticsSiteActivityParams & A>; pathParts: AnalyticsSiteActivityPathParts };

export function analyticsSiteActivityRoute(): AnalyticsSiteActivityRoute;
export function analyticsSiteActivityRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, AnalyticsSiteActivityParams>): AnalyticsSiteActivityRoute<t.TypeOf<A>>;
export function analyticsSiteActivityRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, AnalyticsSiteActivityParams>) {
  return {
    match: (q ? analyticsSiteActivityPath.then(query(t.intersection([analyticsSiteActivityQuery, q]))) : analyticsSiteActivityPath.then(query(analyticsSiteActivityQuery))).then(end),
    pathParts: analyticsSiteActivityPathParts,
  };
}

const analyticsUserActivityPath = lit("issuer-portal").then(lit("analytics")).then(lit("user-activity"));
const analyticsUserActivityPathParts = ["analytics", "user-activity"] as const;
export type AnalyticsUserActivityPathParts = typeof analyticsUserActivityPathParts;

const analyticsUserActivityQuery = t.strict({});
export type AnalyticsUserActivityParams = Describe<typeof analyticsUserActivityPath._A & typeof analyticsUserActivityQuery._A>;

export type AnalyticsUserActivityRoute<A = {}> = { match: Match<AnalyticsUserActivityParams & A>; pathParts: AnalyticsUserActivityPathParts };

export function analyticsUserActivityRoute(): AnalyticsUserActivityRoute;
export function analyticsUserActivityRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, AnalyticsUserActivityParams>): AnalyticsUserActivityRoute<t.TypeOf<A>>;
export function analyticsUserActivityRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, AnalyticsUserActivityParams>) {
  return {
    match: (q ? analyticsUserActivityPath.then(query(t.intersection([analyticsUserActivityQuery, q]))) : analyticsUserActivityPath.then(query(analyticsUserActivityQuery))).then(end),
    pathParts: analyticsUserActivityPathParts,
  };
}

const analyticsUserProfilePath = lit("issuer-portal").then(lit("analytics")).then(lit("user-activity")).then(lit("details"));
const analyticsUserProfilePathParts = ["analytics", "user-activity", "details"] as const;
export type AnalyticsUserProfilePathParts = typeof analyticsUserProfilePathParts;

const analyticsUserProfileQuery = t.exact(t.type({
  "userId": NumberFromString,
  "startDate": LocalDateC,
  "endDate": LocalDateC
}));
export type AnalyticsUserProfileParams = Describe<typeof analyticsUserProfilePath._A & typeof analyticsUserProfileQuery._A>;

export type AnalyticsUserProfileRoute<A = {}> = { match: Match<AnalyticsUserProfileParams & A>; pathParts: AnalyticsUserProfilePathParts };

export function analyticsUserProfileRoute(): AnalyticsUserProfileRoute;
export function analyticsUserProfileRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, AnalyticsUserProfileParams>): AnalyticsUserProfileRoute<t.TypeOf<A>>;
export function analyticsUserProfileRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, AnalyticsUserProfileParams>) {
  return {
    match: (q ? analyticsUserProfilePath.then(query(t.intersection([analyticsUserProfileQuery, q]))) : analyticsUserProfilePath.then(query(analyticsUserProfileQuery))).then(end),
    pathParts: analyticsUserProfilePathParts,
  };
}

const dashboardPath = lit("issuer-portal").then(lit("dashboard"));
const dashboardPathParts = ["dashboard"] as const;
export type DashboardPathParts = typeof dashboardPathParts;

const dashboardQuery = t.strict({});
export type DashboardParams = Describe<typeof dashboardPath._A & typeof dashboardQuery._A>;

export type DashboardRoute<A = {}> = { match: Match<DashboardParams & A>; pathParts: DashboardPathParts };

export function dashboardRoute(): DashboardRoute;
export function dashboardRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, DashboardParams>): DashboardRoute<t.TypeOf<A>>;
export function dashboardRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, DashboardParams>) {
  return {
    match: (q ? dashboardPath.then(query(t.intersection([dashboardQuery, q]))) : dashboardPath.then(query(dashboardQuery))).then(end),
    pathParts: dashboardPathParts,
  };
}

const debtDataDataManagementPath = lit("issuer-portal").then(lit("debt-data")).then(lit("data-management"));
const debtDataDataManagementPathParts = ["debt-data", "data-management"] as const;
export type DebtDataDataManagementPathParts = typeof debtDataDataManagementPathParts;

const debtDataDataManagementQuery = t.strict({});
export type DebtDataDataManagementParams = Describe<typeof debtDataDataManagementPath._A & typeof debtDataDataManagementQuery._A>;

export type DebtDataDataManagementRoute<A = {}> = { match: Match<DebtDataDataManagementParams & A>; pathParts: DebtDataDataManagementPathParts };

export function debtDataDataManagementRoute(): DebtDataDataManagementRoute;
export function debtDataDataManagementRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, DebtDataDataManagementParams>): DebtDataDataManagementRoute<t.TypeOf<A>>;
export function debtDataDataManagementRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, DebtDataDataManagementParams>) {
  return {
    match: (q ? debtDataDataManagementPath.then(query(t.intersection([debtDataDataManagementQuery, q]))) : debtDataDataManagementPath.then(query(debtDataDataManagementQuery))).then(end),
    pathParts: debtDataDataManagementPathParts,
  };
}

const debtDataDataManagementCusip6Path = lit("issuer-portal").then(lit("debt-data")).then(lit("data-management")).then(lit("cusip-6")).then(str("cusip6"));
const debtDataDataManagementCusip6PathParts = ["debt-data", "data-management", "cusip-6", "cusip6"] as const;
export type DebtDataDataManagementCusip6PathParts = typeof debtDataDataManagementCusip6PathParts;

const debtDataDataManagementCusip6Query = t.strict({});
export type DebtDataDataManagementCusip6Params = Describe<typeof debtDataDataManagementCusip6Path._A & typeof debtDataDataManagementCusip6Query._A>;

export type DebtDataDataManagementCusip6Route<A = {}> = { match: Match<DebtDataDataManagementCusip6Params & A>; pathParts: DebtDataDataManagementCusip6PathParts };

export function debtDataDataManagementCusip6Route(): DebtDataDataManagementCusip6Route;
export function debtDataDataManagementCusip6Route<A extends t.Mixed>(q: NoKeyOverlapC<A, DebtDataDataManagementCusip6Params>): DebtDataDataManagementCusip6Route<t.TypeOf<A>>;
export function debtDataDataManagementCusip6Route<A extends t.Mixed>(q?: NoKeyOverlapC<A, DebtDataDataManagementCusip6Params>) {
  return {
    match: (q ? debtDataDataManagementCusip6Path.then(query(t.intersection([debtDataDataManagementCusip6Query, q]))) : debtDataDataManagementCusip6Path.then(query(debtDataDataManagementCusip6Query))).then(end),
    pathParts: debtDataDataManagementCusip6PathParts,
  };
}

const debtDataDataManagementCustomSeriesPath = lit("issuer-portal").then(lit("debt-data")).then(lit("data-management")).then(lit("custom-series-data")).then(int("seriesId"));
const debtDataDataManagementCustomSeriesPathParts = [
  "debt-data", "data-management", "custom-series-data", "seriesId"
] as const;
export type DebtDataDataManagementCustomSeriesPathParts = typeof debtDataDataManagementCustomSeriesPathParts;

const debtDataDataManagementCustomSeriesQuery = t.strict({});
export type DebtDataDataManagementCustomSeriesParams = Describe<typeof debtDataDataManagementCustomSeriesPath._A & typeof debtDataDataManagementCustomSeriesQuery._A>;

export type DebtDataDataManagementCustomSeriesRoute<A = {}> = { match: Match<DebtDataDataManagementCustomSeriesParams & A>; pathParts: DebtDataDataManagementCustomSeriesPathParts };

export function debtDataDataManagementCustomSeriesRoute(): DebtDataDataManagementCustomSeriesRoute;
export function debtDataDataManagementCustomSeriesRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, DebtDataDataManagementCustomSeriesParams>): DebtDataDataManagementCustomSeriesRoute<t.TypeOf<A>>;
export function debtDataDataManagementCustomSeriesRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, DebtDataDataManagementCustomSeriesParams>) {
  return {
    match: (q ? debtDataDataManagementCustomSeriesPath.then(query(t.intersection([debtDataDataManagementCustomSeriesQuery, q]))) : debtDataDataManagementCustomSeriesPath.then(query(debtDataDataManagementCustomSeriesQuery))).then(end),
    pathParts: debtDataDataManagementCustomSeriesPathParts,
  };
}

const debtDataReviewCenterPath = lit("issuer-portal").then(lit("debt-data")).then(lit("data-management")).then(lit("data-review-center"));
const debtDataReviewCenterPathParts = ["debt-data", "data-management", "data-review-center"] as const;
export type DebtDataReviewCenterPathParts = typeof debtDataReviewCenterPathParts;

const debtDataReviewCenterQuery = t.strict({});
export type DebtDataReviewCenterParams = Describe<typeof debtDataReviewCenterPath._A & typeof debtDataReviewCenterQuery._A>;

export type DebtDataReviewCenterRoute<A = {}> = { match: Match<DebtDataReviewCenterParams & A>; pathParts: DebtDataReviewCenterPathParts };

export function debtDataReviewCenterRoute(): DebtDataReviewCenterRoute;
export function debtDataReviewCenterRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, DebtDataReviewCenterParams>): DebtDataReviewCenterRoute<t.TypeOf<A>>;
export function debtDataReviewCenterRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, DebtDataReviewCenterParams>) {
  return {
    match: (q ? debtDataReviewCenterPath.then(query(t.intersection([debtDataReviewCenterQuery, q]))) : debtDataReviewCenterPath.then(query(debtDataReviewCenterQuery))).then(end),
    pathParts: debtDataReviewCenterPathParts,
  };
}

const debtDataReviewDetailsPath = lit("issuer-portal").then(lit("debt-data")).then(lit("data-management")).then(lit("data-review-center")).then(lit("review-details")).then(int("seriesId"));
const debtDataReviewDetailsPathParts = [
  "debt-data", "data-management", "data-review-center", "review-details", "seriesId"
] as const;
export type DebtDataReviewDetailsPathParts = typeof debtDataReviewDetailsPathParts;

const debtDataReviewDetailsQuery = t.strict({});
export type DebtDataReviewDetailsParams = Describe<typeof debtDataReviewDetailsPath._A & typeof debtDataReviewDetailsQuery._A>;

export type DebtDataReviewDetailsRoute<A = {}> = { match: Match<DebtDataReviewDetailsParams & A>; pathParts: DebtDataReviewDetailsPathParts };

export function debtDataReviewDetailsRoute(): DebtDataReviewDetailsRoute;
export function debtDataReviewDetailsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, DebtDataReviewDetailsParams>): DebtDataReviewDetailsRoute<t.TypeOf<A>>;
export function debtDataReviewDetailsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, DebtDataReviewDetailsParams>) {
  return {
    match: (q ? debtDataReviewDetailsPath.then(query(t.intersection([debtDataReviewDetailsQuery, q]))) : debtDataReviewDetailsPath.then(query(debtDataReviewDetailsQuery))).then(end),
    pathParts: debtDataReviewDetailsPathParts,
  };
}

const debtDataDataManagementSeriesPath = lit("issuer-portal").then(lit("debt-data")).then(lit("data-management")).then(lit("series-data")).then(int("seriesId"));
const debtDataDataManagementSeriesPathParts = ["debt-data", "data-management", "series-data", "seriesId"] as const;
export type DebtDataDataManagementSeriesPathParts = typeof debtDataDataManagementSeriesPathParts;

const debtDataDataManagementSeriesQuery = t.strict({});
export type DebtDataDataManagementSeriesParams = Describe<typeof debtDataDataManagementSeriesPath._A & typeof debtDataDataManagementSeriesQuery._A>;

export type DebtDataDataManagementSeriesRoute<A = {}> = { match: Match<DebtDataDataManagementSeriesParams & A>; pathParts: DebtDataDataManagementSeriesPathParts };

export function debtDataDataManagementSeriesRoute(): DebtDataDataManagementSeriesRoute;
export function debtDataDataManagementSeriesRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, DebtDataDataManagementSeriesParams>): DebtDataDataManagementSeriesRoute<t.TypeOf<A>>;
export function debtDataDataManagementSeriesRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, DebtDataDataManagementSeriesParams>) {
  return {
    match: (q ? debtDataDataManagementSeriesPath.then(query(t.intersection([debtDataDataManagementSeriesQuery, q]))) : debtDataDataManagementSeriesPath.then(query(debtDataDataManagementSeriesQuery))).then(end),
    pathParts: debtDataDataManagementSeriesPathParts,
  };
}

const debtDataDebtProfilePath = lit("issuer-portal").then(lit("debt-data")).then(lit("debt-profile"));
const debtDataDebtProfilePathParts = ["debt-data", "debt-profile"] as const;
export type DebtDataDebtProfilePathParts = typeof debtDataDebtProfilePathParts;

const debtDataDebtProfileQuery = t.strict({});
export type DebtDataDebtProfileParams = Describe<typeof debtDataDebtProfilePath._A & typeof debtDataDebtProfileQuery._A>;

export type DebtDataDebtProfileRoute<A = {}> = { match: Match<DebtDataDebtProfileParams & A>; pathParts: DebtDataDebtProfilePathParts };

export function debtDataDebtProfileRoute(): DebtDataDebtProfileRoute;
export function debtDataDebtProfileRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, DebtDataDebtProfileParams>): DebtDataDebtProfileRoute<t.TypeOf<A>>;
export function debtDataDebtProfileRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, DebtDataDebtProfileParams>) {
  return {
    match: (q ? debtDataDebtProfilePath.then(query(t.intersection([debtDataDebtProfileQuery, q]))) : debtDataDebtProfilePath.then(query(debtDataDebtProfileQuery))).then(end),
    pathParts: debtDataDebtProfilePathParts,
  };
}

const debtDataCustomSeriesBreakdownPath = lit("issuer-portal").then(lit("debt-data")).then(lit("debt-profile")).then(lit("custom-series-breakdown")).then(int("seriesId"));
const debtDataCustomSeriesBreakdownPathParts = [
  "debt-data", "debt-profile", "custom-series-breakdown", "seriesId"
] as const;
export type DebtDataCustomSeriesBreakdownPathParts = typeof debtDataCustomSeriesBreakdownPathParts;

const debtDataCustomSeriesBreakdownQuery = t.strict({});
export type DebtDataCustomSeriesBreakdownParams = Describe<typeof debtDataCustomSeriesBreakdownPath._A & typeof debtDataCustomSeriesBreakdownQuery._A>;

export type DebtDataCustomSeriesBreakdownRoute<A = {}> = { match: Match<DebtDataCustomSeriesBreakdownParams & A>; pathParts: DebtDataCustomSeriesBreakdownPathParts };

export function debtDataCustomSeriesBreakdownRoute(): DebtDataCustomSeriesBreakdownRoute;
export function debtDataCustomSeriesBreakdownRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, DebtDataCustomSeriesBreakdownParams>): DebtDataCustomSeriesBreakdownRoute<t.TypeOf<A>>;
export function debtDataCustomSeriesBreakdownRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, DebtDataCustomSeriesBreakdownParams>) {
  return {
    match: (q ? debtDataCustomSeriesBreakdownPath.then(query(t.intersection([debtDataCustomSeriesBreakdownQuery, q]))) : debtDataCustomSeriesBreakdownPath.then(query(debtDataCustomSeriesBreakdownQuery))).then(end),
    pathParts: debtDataCustomSeriesBreakdownPathParts,
  };
}

const debtDataSeriesBreakdownPath = lit("issuer-portal").then(lit("debt-data")).then(lit("debt-profile")).then(lit("series-breakdown")).then(int("seriesId"));
const debtDataSeriesBreakdownPathParts = ["debt-data", "debt-profile", "series-breakdown", "seriesId"] as const;
export type DebtDataSeriesBreakdownPathParts = typeof debtDataSeriesBreakdownPathParts;

const debtDataSeriesBreakdownQuery = t.strict({});
export type DebtDataSeriesBreakdownParams = Describe<typeof debtDataSeriesBreakdownPath._A & typeof debtDataSeriesBreakdownQuery._A>;

export type DebtDataSeriesBreakdownRoute<A = {}> = { match: Match<DebtDataSeriesBreakdownParams & A>; pathParts: DebtDataSeriesBreakdownPathParts };

export function debtDataSeriesBreakdownRoute(): DebtDataSeriesBreakdownRoute;
export function debtDataSeriesBreakdownRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, DebtDataSeriesBreakdownParams>): DebtDataSeriesBreakdownRoute<t.TypeOf<A>>;
export function debtDataSeriesBreakdownRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, DebtDataSeriesBreakdownParams>) {
  return {
    match: (q ? debtDataSeriesBreakdownPath.then(query(t.intersection([debtDataSeriesBreakdownQuery, q]))) : debtDataSeriesBreakdownPath.then(query(debtDataSeriesBreakdownQuery))).then(end),
    pathParts: debtDataSeriesBreakdownPathParts,
  };
}

const debtDataYearlyBreakdownPath = lit("issuer-portal").then(lit("debt-data")).then(lit("debt-profile")).then(lit("yearly-breakdown")).then(int("year"));
const debtDataYearlyBreakdownPathParts = ["debt-data", "debt-profile", "yearly-breakdown", "year"] as const;
export type DebtDataYearlyBreakdownPathParts = typeof debtDataYearlyBreakdownPathParts;

const debtDataYearlyBreakdownQuery = t.strict({});
export type DebtDataYearlyBreakdownParams = Describe<typeof debtDataYearlyBreakdownPath._A & typeof debtDataYearlyBreakdownQuery._A>;

export type DebtDataYearlyBreakdownRoute<A = {}> = { match: Match<DebtDataYearlyBreakdownParams & A>; pathParts: DebtDataYearlyBreakdownPathParts };

export function debtDataYearlyBreakdownRoute(): DebtDataYearlyBreakdownRoute;
export function debtDataYearlyBreakdownRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, DebtDataYearlyBreakdownParams>): DebtDataYearlyBreakdownRoute<t.TypeOf<A>>;
export function debtDataYearlyBreakdownRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, DebtDataYearlyBreakdownParams>) {
  return {
    match: (q ? debtDataYearlyBreakdownPath.then(query(t.intersection([debtDataYearlyBreakdownQuery, q]))) : debtDataYearlyBreakdownPath.then(query(debtDataYearlyBreakdownQuery))).then(end),
    pathParts: debtDataYearlyBreakdownPathParts,
  };
}

const debtDataSettingsPath = lit("issuer-portal").then(lit("debt-data")).then(lit("settings"));
const debtDataSettingsPathParts = ["debt-data", "settings"] as const;
export type DebtDataSettingsPathParts = typeof debtDataSettingsPathParts;

const debtDataSettingsQuery = t.strict({});
export type DebtDataSettingsParams = Describe<typeof debtDataSettingsPath._A & typeof debtDataSettingsQuery._A>;

export type DebtDataSettingsRoute<A = {}> = { match: Match<DebtDataSettingsParams & A>; pathParts: DebtDataSettingsPathParts };

export function debtDataSettingsRoute(): DebtDataSettingsRoute;
export function debtDataSettingsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, DebtDataSettingsParams>): DebtDataSettingsRoute<t.TypeOf<A>>;
export function debtDataSettingsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, DebtDataSettingsParams>) {
  return {
    match: (q ? debtDataSettingsPath.then(query(t.intersection([debtDataSettingsQuery, q]))) : debtDataSettingsPath.then(query(debtDataSettingsQuery))).then(end),
    pathParts: debtDataSettingsPathParts,
  };
}

const debtDataTagSettingsPath = lit("issuer-portal").then(lit("debt-data")).then(lit("settings")).then(lit("tag")).then(int("tagId"));
const debtDataTagSettingsPathParts = ["debt-data", "settings", "tag", "tagId"] as const;
export type DebtDataTagSettingsPathParts = typeof debtDataTagSettingsPathParts;

const debtDataTagSettingsQuery = t.strict({});
export type DebtDataTagSettingsParams = Describe<typeof debtDataTagSettingsPath._A & typeof debtDataTagSettingsQuery._A>;

export type DebtDataTagSettingsRoute<A = {}> = { match: Match<DebtDataTagSettingsParams & A>; pathParts: DebtDataTagSettingsPathParts };

export function debtDataTagSettingsRoute(): DebtDataTagSettingsRoute;
export function debtDataTagSettingsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, DebtDataTagSettingsParams>): DebtDataTagSettingsRoute<t.TypeOf<A>>;
export function debtDataTagSettingsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, DebtDataTagSettingsParams>) {
  return {
    match: (q ? debtDataTagSettingsPath.then(query(t.intersection([debtDataTagSettingsQuery, q]))) : debtDataTagSettingsPath.then(query(debtDataTagSettingsQuery))).then(end),
    pathParts: debtDataTagSettingsPathParts,
  };
}

const marketInsightsPath = lit("issuer-portal").then(lit("market-insights"));
const marketInsightsPathParts = ["market-insights"] as const;
export type MarketInsightsPathParts = typeof marketInsightsPathParts;

const marketInsightsQuery = t.strict({});
export type MarketInsightsParams = Describe<typeof marketInsightsPath._A & typeof marketInsightsQuery._A>;

export type MarketInsightsRoute<A = {}> = { match: Match<MarketInsightsParams & A>; pathParts: MarketInsightsPathParts };

export function marketInsightsRoute(): MarketInsightsRoute;
export function marketInsightsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MarketInsightsParams>): MarketInsightsRoute<t.TypeOf<A>>;
export function marketInsightsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MarketInsightsParams>) {
  return {
    match: (q ? marketInsightsPath.then(query(t.intersection([marketInsightsQuery, q]))) : marketInsightsPath.then(query(marketInsightsQuery))).then(end),
    pathParts: marketInsightsPathParts,
  };
}

const marketInsightsArticlePath = lit("issuer-portal").then(lit("market-insights")).then(int("id"));
const marketInsightsArticlePathParts = ["market-insights", "id"] as const;
export type MarketInsightsArticlePathParts = typeof marketInsightsArticlePathParts;

const marketInsightsArticleQuery = t.exact(t.partial({
  "preview": BooleanFromString
}));
export type MarketInsightsArticleParamsRaw = Describe<typeof marketInsightsArticlePath._A & typeof marketInsightsArticleQuery._A>;
export type MarketInsightsArticleParams = Describe<NullableToOptionalFields<MarketInsightsArticleParamsRaw>>;

export type MarketInsightsArticleRoute<A = {}> = { match: Match<MarketInsightsArticleParamsRaw & A>; pathParts: MarketInsightsArticlePathParts };

export function marketInsightsArticleRoute(): MarketInsightsArticleRoute;
export function marketInsightsArticleRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MarketInsightsArticleParamsRaw>): MarketInsightsArticleRoute<t.TypeOf<A>>;
export function marketInsightsArticleRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MarketInsightsArticleParamsRaw>) {
  return {
    match: (q ? marketInsightsArticlePath.then(query(t.intersection([marketInsightsArticleQuery, q]))) : marketInsightsArticlePath.then(query(marketInsightsArticleQuery))).then(end),
    pathParts: marketInsightsArticlePathParts,
  };
}

const mySiteAboutPath = lit("issuer-portal").then(lit("my-site")).then(lit("about"));
const mySiteAboutPathParts = ["my-site", "about"] as const;
export type MySiteAboutPathParts = typeof mySiteAboutPathParts;

const mySiteAboutQuery = t.strict({});
export type MySiteAboutParams = Describe<typeof mySiteAboutPath._A & typeof mySiteAboutQuery._A>;

export type MySiteAboutRoute<A = {}> = { match: Match<MySiteAboutParams & A>; pathParts: MySiteAboutPathParts };

export function mySiteAboutRoute(): MySiteAboutRoute;
export function mySiteAboutRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteAboutParams>): MySiteAboutRoute<t.TypeOf<A>>;
export function mySiteAboutRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteAboutParams>) {
  return {
    match: (q ? mySiteAboutPath.then(query(t.intersection([mySiteAboutQuery, q]))) : mySiteAboutPath.then(query(mySiteAboutQuery))).then(end),
    pathParts: mySiteAboutPathParts,
  };
}

const mySiteAboutEsgProgramPath = lit("issuer-portal").then(lit("my-site")).then(lit("about")).then(lit("esg-program"));
const mySiteAboutEsgProgramPathParts = ["my-site", "about", "esg-program"] as const;
export type MySiteAboutEsgProgramPathParts = typeof mySiteAboutEsgProgramPathParts;

const mySiteAboutEsgProgramQuery = t.strict({});
export type MySiteAboutEsgProgramParams = Describe<typeof mySiteAboutEsgProgramPath._A & typeof mySiteAboutEsgProgramQuery._A>;

export type MySiteAboutEsgProgramRoute<A = {}> = { match: Match<MySiteAboutEsgProgramParams & A>; pathParts: MySiteAboutEsgProgramPathParts };

export function mySiteAboutEsgProgramRoute(): MySiteAboutEsgProgramRoute;
export function mySiteAboutEsgProgramRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteAboutEsgProgramParams>): MySiteAboutEsgProgramRoute<t.TypeOf<A>>;
export function mySiteAboutEsgProgramRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteAboutEsgProgramParams>) {
  return {
    match: (q ? mySiteAboutEsgProgramPath.then(query(t.intersection([mySiteAboutEsgProgramQuery, q]))) : mySiteAboutEsgProgramPath.then(query(mySiteAboutEsgProgramQuery))).then(end),
    pathParts: mySiteAboutEsgProgramPathParts,
  };
}

const mySiteAboutNewsAndEventsPath = lit("issuer-portal").then(lit("my-site")).then(lit("about")).then(lit("news-and-events"));
const mySiteAboutNewsAndEventsPathParts = ["my-site", "about", "news-and-events"] as const;
export type MySiteAboutNewsAndEventsPathParts = typeof mySiteAboutNewsAndEventsPathParts;

const mySiteAboutNewsAndEventsQuery = t.strict({});
export type MySiteAboutNewsAndEventsParams = Describe<typeof mySiteAboutNewsAndEventsPath._A & typeof mySiteAboutNewsAndEventsQuery._A>;

export type MySiteAboutNewsAndEventsRoute<A = {}> = { match: Match<MySiteAboutNewsAndEventsParams & A>; pathParts: MySiteAboutNewsAndEventsPathParts };

export function mySiteAboutNewsAndEventsRoute(): MySiteAboutNewsAndEventsRoute;
export function mySiteAboutNewsAndEventsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteAboutNewsAndEventsParams>): MySiteAboutNewsAndEventsRoute<t.TypeOf<A>>;
export function mySiteAboutNewsAndEventsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteAboutNewsAndEventsParams>) {
  return {
    match: (q ? mySiteAboutNewsAndEventsPath.then(query(t.intersection([mySiteAboutNewsAndEventsQuery, q]))) : mySiteAboutNewsAndEventsPath.then(query(mySiteAboutNewsAndEventsQuery))).then(end),
    pathParts: mySiteAboutNewsAndEventsPathParts,
  };
}

const mySiteAboutProjectsPath = lit("issuer-portal").then(lit("my-site")).then(lit("about")).then(lit("projects"));
const mySiteAboutProjectsPathParts = ["my-site", "about", "projects"] as const;
export type MySiteAboutProjectsPathParts = typeof mySiteAboutProjectsPathParts;

const mySiteAboutProjectsQuery = t.strict({});
export type MySiteAboutProjectsParams = Describe<typeof mySiteAboutProjectsPath._A & typeof mySiteAboutProjectsQuery._A>;

export type MySiteAboutProjectsRoute<A = {}> = { match: Match<MySiteAboutProjectsParams & A>; pathParts: MySiteAboutProjectsPathParts };

export function mySiteAboutProjectsRoute(): MySiteAboutProjectsRoute;
export function mySiteAboutProjectsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteAboutProjectsParams>): MySiteAboutProjectsRoute<t.TypeOf<A>>;
export function mySiteAboutProjectsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteAboutProjectsParams>) {
  return {
    match: (q ? mySiteAboutProjectsPath.then(query(t.intersection([mySiteAboutProjectsQuery, q]))) : mySiteAboutProjectsPath.then(query(mySiteAboutProjectsQuery))).then(end),
    pathParts: mySiteAboutProjectsPathParts,
  };
}

const mySiteAboutTeamPath = lit("issuer-portal").then(lit("my-site")).then(lit("about")).then(lit("team"));
const mySiteAboutTeamPathParts = ["my-site", "about", "team"] as const;
export type MySiteAboutTeamPathParts = typeof mySiteAboutTeamPathParts;

const mySiteAboutTeamQuery = t.strict({});
export type MySiteAboutTeamParams = Describe<typeof mySiteAboutTeamPath._A & typeof mySiteAboutTeamQuery._A>;

export type MySiteAboutTeamRoute<A = {}> = { match: Match<MySiteAboutTeamParams & A>; pathParts: MySiteAboutTeamPathParts };

export function mySiteAboutTeamRoute(): MySiteAboutTeamRoute;
export function mySiteAboutTeamRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteAboutTeamParams>): MySiteAboutTeamRoute<t.TypeOf<A>>;
export function mySiteAboutTeamRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteAboutTeamParams>) {
  return {
    match: (q ? mySiteAboutTeamPath.then(query(t.intersection([mySiteAboutTeamQuery, q]))) : mySiteAboutTeamPath.then(query(mySiteAboutTeamQuery))).then(end),
    pathParts: mySiteAboutTeamPathParts,
  };
}

const mySiteBondsPath = lit("issuer-portal").then(lit("my-site")).then(lit("bonds"));
const mySiteBondsPathParts = ["my-site", "bonds"] as const;
export type MySiteBondsPathParts = typeof mySiteBondsPathParts;

const mySiteBondsQuery = t.strict({});
export type MySiteBondsParams = Describe<typeof mySiteBondsPath._A & typeof mySiteBondsQuery._A>;

export type MySiteBondsRoute<A = {}> = { match: Match<MySiteBondsParams & A>; pathParts: MySiteBondsPathParts };

export function mySiteBondsRoute(): MySiteBondsRoute;
export function mySiteBondsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteBondsParams>): MySiteBondsRoute<t.TypeOf<A>>;
export function mySiteBondsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteBondsParams>) {
  return {
    match: (q ? mySiteBondsPath.then(query(t.intersection([mySiteBondsQuery, q]))) : mySiteBondsPath.then(query(mySiteBondsQuery))).then(end),
    pathParts: mySiteBondsPathParts,
  };
}

const mySiteBondsParticipantsPath = lit("issuer-portal").then(lit("my-site")).then(lit("bonds")).then(lit("participants"));
const mySiteBondsParticipantsPathParts = ["my-site", "bonds", "participants"] as const;
export type MySiteBondsParticipantsPathParts = typeof mySiteBondsParticipantsPathParts;

const mySiteBondsParticipantsQuery = t.strict({});
export type MySiteBondsParticipantsParams = Describe<typeof mySiteBondsParticipantsPath._A & typeof mySiteBondsParticipantsQuery._A>;

export type MySiteBondsParticipantsRoute<A = {}> = { match: Match<MySiteBondsParticipantsParams & A>; pathParts: MySiteBondsParticipantsPathParts };

export function mySiteBondsParticipantsRoute(): MySiteBondsParticipantsRoute;
export function mySiteBondsParticipantsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteBondsParticipantsParams>): MySiteBondsParticipantsRoute<t.TypeOf<A>>;
export function mySiteBondsParticipantsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteBondsParticipantsParams>) {
  return {
    match: (q ? mySiteBondsParticipantsPath.then(query(t.intersection([mySiteBondsParticipantsQuery, q]))) : mySiteBondsParticipantsPath.then(query(mySiteBondsParticipantsQuery))).then(end),
    pathParts: mySiteBondsParticipantsPathParts,
  };
}

const mySiteBondsProgramsPath = lit("issuer-portal").then(lit("my-site")).then(lit("bonds")).then(lit("programs"));
const mySiteBondsProgramsPathParts = ["my-site", "bonds", "programs"] as const;
export type MySiteBondsProgramsPathParts = typeof mySiteBondsProgramsPathParts;

const mySiteBondsProgramsQuery = t.strict({});
export type MySiteBondsProgramsParams = Describe<typeof mySiteBondsProgramsPath._A & typeof mySiteBondsProgramsQuery._A>;

export type MySiteBondsProgramsRoute<A = {}> = { match: Match<MySiteBondsProgramsParams & A>; pathParts: MySiteBondsProgramsPathParts };

export function mySiteBondsProgramsRoute(): MySiteBondsProgramsRoute;
export function mySiteBondsProgramsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteBondsProgramsParams>): MySiteBondsProgramsRoute<t.TypeOf<A>>;
export function mySiteBondsProgramsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteBondsProgramsParams>) {
  return {
    match: (q ? mySiteBondsProgramsPath.then(query(t.intersection([mySiteBondsProgramsQuery, q]))) : mySiteBondsProgramsPath.then(query(mySiteBondsProgramsQuery))).then(end),
    pathParts: mySiteBondsProgramsPathParts,
  };
}

const mySiteBondsRatingsPath = lit("issuer-portal").then(lit("my-site")).then(lit("bonds")).then(lit("ratings"));
const mySiteBondsRatingsPathParts = ["my-site", "bonds", "ratings"] as const;
export type MySiteBondsRatingsPathParts = typeof mySiteBondsRatingsPathParts;

const mySiteBondsRatingsQuery = t.strict({});
export type MySiteBondsRatingsParams = Describe<typeof mySiteBondsRatingsPath._A & typeof mySiteBondsRatingsQuery._A>;

export type MySiteBondsRatingsRoute<A = {}> = { match: Match<MySiteBondsRatingsParams & A>; pathParts: MySiteBondsRatingsPathParts };

export function mySiteBondsRatingsRoute(): MySiteBondsRatingsRoute;
export function mySiteBondsRatingsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteBondsRatingsParams>): MySiteBondsRatingsRoute<t.TypeOf<A>>;
export function mySiteBondsRatingsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteBondsRatingsParams>) {
  return {
    match: (q ? mySiteBondsRatingsPath.then(query(t.intersection([mySiteBondsRatingsQuery, q]))) : mySiteBondsRatingsPath.then(query(mySiteBondsRatingsQuery))).then(end),
    pathParts: mySiteBondsRatingsPathParts,
  };
}

const mySiteBondsRfpsPath = lit("issuer-portal").then(lit("my-site")).then(lit("bonds")).then(lit("rfps"));
const mySiteBondsRfpsPathParts = ["my-site", "bonds", "rfps"] as const;
export type MySiteBondsRfpsPathParts = typeof mySiteBondsRfpsPathParts;

const mySiteBondsRfpsQuery = t.strict({});
export type MySiteBondsRfpsParams = Describe<typeof mySiteBondsRfpsPath._A & typeof mySiteBondsRfpsQuery._A>;

export type MySiteBondsRfpsRoute<A = {}> = { match: Match<MySiteBondsRfpsParams & A>; pathParts: MySiteBondsRfpsPathParts };

export function mySiteBondsRfpsRoute(): MySiteBondsRfpsRoute;
export function mySiteBondsRfpsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteBondsRfpsParams>): MySiteBondsRfpsRoute<t.TypeOf<A>>;
export function mySiteBondsRfpsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteBondsRfpsParams>) {
  return {
    match: (q ? mySiteBondsRfpsPath.then(query(t.intersection([mySiteBondsRfpsQuery, q]))) : mySiteBondsRfpsPath.then(query(mySiteBondsRfpsQuery))).then(end),
    pathParts: mySiteBondsRfpsPathParts,
  };
}

const mySiteBondsRfpsBidsPath = lit("issuer-portal").then(lit("my-site")).then(lit("bonds")).then(lit("rfps")).then(int("rfpId")).then(lit("bids"));
const mySiteBondsRfpsBidsPathParts = ["my-site", "bonds", "rfps", "rfpId", "bids"] as const;
export type MySiteBondsRfpsBidsPathParts = typeof mySiteBondsRfpsBidsPathParts;

const mySiteBondsRfpsBidsQuery = t.strict({});
export type MySiteBondsRfpsBidsParams = Describe<typeof mySiteBondsRfpsBidsPath._A & typeof mySiteBondsRfpsBidsQuery._A>;

export type MySiteBondsRfpsBidsRoute<A = {}> = { match: Match<MySiteBondsRfpsBidsParams & A>; pathParts: MySiteBondsRfpsBidsPathParts };

export function mySiteBondsRfpsBidsRoute(): MySiteBondsRfpsBidsRoute;
export function mySiteBondsRfpsBidsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteBondsRfpsBidsParams>): MySiteBondsRfpsBidsRoute<t.TypeOf<A>>;
export function mySiteBondsRfpsBidsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteBondsRfpsBidsParams>) {
  return {
    match: (q ? mySiteBondsRfpsBidsPath.then(query(t.intersection([mySiteBondsRfpsBidsQuery, q]))) : mySiteBondsRfpsBidsPath.then(query(mySiteBondsRfpsBidsQuery))).then(end),
    pathParts: mySiteBondsRfpsBidsPathParts,
  };
}

const mySiteBondsRoadshowsPath = lit("issuer-portal").then(lit("my-site")).then(lit("bonds")).then(lit("roadshows"));
const mySiteBondsRoadshowsPathParts = ["my-site", "bonds", "roadshows"] as const;
export type MySiteBondsRoadshowsPathParts = typeof mySiteBondsRoadshowsPathParts;

const mySiteBondsRoadshowsQuery = t.strict({});
export type MySiteBondsRoadshowsParams = Describe<typeof mySiteBondsRoadshowsPath._A & typeof mySiteBondsRoadshowsQuery._A>;

export type MySiteBondsRoadshowsRoute<A = {}> = { match: Match<MySiteBondsRoadshowsParams & A>; pathParts: MySiteBondsRoadshowsPathParts };

export function mySiteBondsRoadshowsRoute(): MySiteBondsRoadshowsRoute;
export function mySiteBondsRoadshowsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteBondsRoadshowsParams>): MySiteBondsRoadshowsRoute<t.TypeOf<A>>;
export function mySiteBondsRoadshowsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteBondsRoadshowsParams>) {
  return {
    match: (q ? mySiteBondsRoadshowsPath.then(query(t.intersection([mySiteBondsRoadshowsQuery, q]))) : mySiteBondsRoadshowsPath.then(query(mySiteBondsRoadshowsQuery))).then(end),
    pathParts: mySiteBondsRoadshowsPathParts,
  };
}

const mySiteChangeApprovalPath = lit("issuer-portal").then(lit("my-site")).then(lit("change-approval"));
const mySiteChangeApprovalPathParts = ["my-site", "change-approval"] as const;
export type MySiteChangeApprovalPathParts = typeof mySiteChangeApprovalPathParts;

const mySiteChangeApprovalQuery = t.strict({});
export type MySiteChangeApprovalParams = Describe<typeof mySiteChangeApprovalPath._A & typeof mySiteChangeApprovalQuery._A>;

export type MySiteChangeApprovalRoute<A = {}> = { match: Match<MySiteChangeApprovalParams & A>; pathParts: MySiteChangeApprovalPathParts };

export function mySiteChangeApprovalRoute(): MySiteChangeApprovalRoute;
export function mySiteChangeApprovalRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteChangeApprovalParams>): MySiteChangeApprovalRoute<t.TypeOf<A>>;
export function mySiteChangeApprovalRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteChangeApprovalParams>) {
  return {
    match: (q ? mySiteChangeApprovalPath.then(query(t.intersection([mySiteChangeApprovalQuery, q]))) : mySiteChangeApprovalPath.then(query(mySiteChangeApprovalQuery))).then(end),
    pathParts: mySiteChangeApprovalPathParts,
  };
}

const mySiteCustomPagesPath = lit("issuer-portal").then(lit("my-site")).then(lit("custom-pages"));
const mySiteCustomPagesPathParts = ["my-site", "custom-pages"] as const;
export type MySiteCustomPagesPathParts = typeof mySiteCustomPagesPathParts;

const mySiteCustomPagesQuery = t.strict({});
export type MySiteCustomPagesParams = Describe<typeof mySiteCustomPagesPath._A & typeof mySiteCustomPagesQuery._A>;

export type MySiteCustomPagesRoute<A = {}> = { match: Match<MySiteCustomPagesParams & A>; pathParts: MySiteCustomPagesPathParts };

export function mySiteCustomPagesRoute(): MySiteCustomPagesRoute;
export function mySiteCustomPagesRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteCustomPagesParams>): MySiteCustomPagesRoute<t.TypeOf<A>>;
export function mySiteCustomPagesRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteCustomPagesParams>) {
  return {
    match: (q ? mySiteCustomPagesPath.then(query(t.intersection([mySiteCustomPagesQuery, q]))) : mySiteCustomPagesPath.then(query(mySiteCustomPagesQuery))).then(end),
    pathParts: mySiteCustomPagesPathParts,
  };
}

const mySiteDocumentsPath = lit("issuer-portal").then(lit("my-site")).then(lit("documents"));
const mySiteDocumentsPathParts = ["my-site", "documents"] as const;
export type MySiteDocumentsPathParts = typeof mySiteDocumentsPathParts;

const mySiteDocumentsQuery = t.strict({});
export type MySiteDocumentsParams = Describe<typeof mySiteDocumentsPath._A & typeof mySiteDocumentsQuery._A>;

export type MySiteDocumentsRoute<A = {}> = { match: Match<MySiteDocumentsParams & A>; pathParts: MySiteDocumentsPathParts };

export function mySiteDocumentsRoute(): MySiteDocumentsRoute;
export function mySiteDocumentsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteDocumentsParams>): MySiteDocumentsRoute<t.TypeOf<A>>;
export function mySiteDocumentsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteDocumentsParams>) {
  return {
    match: (q ? mySiteDocumentsPath.then(query(t.intersection([mySiteDocumentsQuery, q]))) : mySiteDocumentsPath.then(query(mySiteDocumentsQuery))).then(end),
    pathParts: mySiteDocumentsPathParts,
  };
}

const mySiteDocumentsCategoriesPath = lit("issuer-portal").then(lit("my-site")).then(lit("documents")).then(lit("categories"));
const mySiteDocumentsCategoriesPathParts = ["my-site", "documents", "categories"] as const;
export type MySiteDocumentsCategoriesPathParts = typeof mySiteDocumentsCategoriesPathParts;

const mySiteDocumentsCategoriesQuery = t.strict({});
export type MySiteDocumentsCategoriesParams = Describe<typeof mySiteDocumentsCategoriesPath._A & typeof mySiteDocumentsCategoriesQuery._A>;

export type MySiteDocumentsCategoriesRoute<A = {}> = { match: Match<MySiteDocumentsCategoriesParams & A>; pathParts: MySiteDocumentsCategoriesPathParts };

export function mySiteDocumentsCategoriesRoute(): MySiteDocumentsCategoriesRoute;
export function mySiteDocumentsCategoriesRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteDocumentsCategoriesParams>): MySiteDocumentsCategoriesRoute<t.TypeOf<A>>;
export function mySiteDocumentsCategoriesRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteDocumentsCategoriesParams>) {
  return {
    match: (q ? mySiteDocumentsCategoriesPath.then(query(t.intersection([mySiteDocumentsCategoriesQuery, q]))) : mySiteDocumentsCategoriesPath.then(query(mySiteDocumentsCategoriesQuery))).then(end),
    pathParts: mySiteDocumentsCategoriesPathParts,
  };
}

const mySiteDocumentsIrmaLetterPath = lit("issuer-portal").then(lit("my-site")).then(lit("documents")).then(lit("irma-letter"));
const mySiteDocumentsIrmaLetterPathParts = ["my-site", "documents", "irma-letter"] as const;
export type MySiteDocumentsIrmaLetterPathParts = typeof mySiteDocumentsIrmaLetterPathParts;

const mySiteDocumentsIrmaLetterQuery = t.strict({});
export type MySiteDocumentsIrmaLetterParams = Describe<typeof mySiteDocumentsIrmaLetterPath._A & typeof mySiteDocumentsIrmaLetterQuery._A>;

export type MySiteDocumentsIrmaLetterRoute<A = {}> = { match: Match<MySiteDocumentsIrmaLetterParams & A>; pathParts: MySiteDocumentsIrmaLetterPathParts };

export function mySiteDocumentsIrmaLetterRoute(): MySiteDocumentsIrmaLetterRoute;
export function mySiteDocumentsIrmaLetterRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteDocumentsIrmaLetterParams>): MySiteDocumentsIrmaLetterRoute<t.TypeOf<A>>;
export function mySiteDocumentsIrmaLetterRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteDocumentsIrmaLetterParams>) {
  return {
    match: (q ? mySiteDocumentsIrmaLetterPath.then(query(t.intersection([mySiteDocumentsIrmaLetterQuery, q]))) : mySiteDocumentsIrmaLetterPath.then(query(mySiteDocumentsIrmaLetterQuery))).then(end),
    pathParts: mySiteDocumentsIrmaLetterPathParts,
  };
}

const mySiteHomePath = lit("issuer-portal").then(lit("my-site")).then(lit("home"));
const mySiteHomePathParts = ["my-site", "home"] as const;
export type MySiteHomePathParts = typeof mySiteHomePathParts;

const mySiteHomeQuery = t.strict({});
export type MySiteHomeParams = Describe<typeof mySiteHomePath._A & typeof mySiteHomeQuery._A>;

export type MySiteHomeRoute<A = {}> = { match: Match<MySiteHomeParams & A>; pathParts: MySiteHomePathParts };

export function mySiteHomeRoute(): MySiteHomeRoute;
export function mySiteHomeRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteHomeParams>): MySiteHomeRoute<t.TypeOf<A>>;
export function mySiteHomeRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteHomeParams>) {
  return {
    match: (q ? mySiteHomePath.then(query(t.intersection([mySiteHomeQuery, q]))) : mySiteHomePath.then(query(mySiteHomeQuery))).then(end),
    pathParts: mySiteHomePathParts,
  };
}

const mySiteResourcesContactPath = lit("issuer-portal").then(lit("my-site")).then(lit("resources")).then(lit("contact"));
const mySiteResourcesContactPathParts = ["my-site", "resources", "contact"] as const;
export type MySiteResourcesContactPathParts = typeof mySiteResourcesContactPathParts;

const mySiteResourcesContactQuery = t.strict({});
export type MySiteResourcesContactParams = Describe<typeof mySiteResourcesContactPath._A & typeof mySiteResourcesContactQuery._A>;

export type MySiteResourcesContactRoute<A = {}> = { match: Match<MySiteResourcesContactParams & A>; pathParts: MySiteResourcesContactPathParts };

export function mySiteResourcesContactRoute(): MySiteResourcesContactRoute;
export function mySiteResourcesContactRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteResourcesContactParams>): MySiteResourcesContactRoute<t.TypeOf<A>>;
export function mySiteResourcesContactRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteResourcesContactParams>) {
  return {
    match: (q ? mySiteResourcesContactPath.then(query(t.intersection([mySiteResourcesContactQuery, q]))) : mySiteResourcesContactPath.then(query(mySiteResourcesContactQuery))).then(end),
    pathParts: mySiteResourcesContactPathParts,
  };
}

const mySiteResourcesCusip6sPath = lit("issuer-portal").then(lit("my-site")).then(lit("resources")).then(lit("cusip6s"));
const mySiteResourcesCusip6sPathParts = ["my-site", "resources", "cusip6s"] as const;
export type MySiteResourcesCusip6sPathParts = typeof mySiteResourcesCusip6sPathParts;

const mySiteResourcesCusip6sQuery = t.strict({});
export type MySiteResourcesCusip6sParams = Describe<typeof mySiteResourcesCusip6sPath._A & typeof mySiteResourcesCusip6sQuery._A>;

export type MySiteResourcesCusip6sRoute<A = {}> = { match: Match<MySiteResourcesCusip6sParams & A>; pathParts: MySiteResourcesCusip6sPathParts };

export function mySiteResourcesCusip6sRoute(): MySiteResourcesCusip6sRoute;
export function mySiteResourcesCusip6sRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteResourcesCusip6sParams>): MySiteResourcesCusip6sRoute<t.TypeOf<A>>;
export function mySiteResourcesCusip6sRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteResourcesCusip6sParams>) {
  return {
    match: (q ? mySiteResourcesCusip6sPath.then(query(t.intersection([mySiteResourcesCusip6sQuery, q]))) : mySiteResourcesCusip6sPath.then(query(mySiteResourcesCusip6sQuery))).then(end),
    pathParts: mySiteResourcesCusip6sPathParts,
  };
}

const mySiteResourcesCusip9sPath = lit("issuer-portal").then(lit("my-site")).then(lit("resources")).then(lit("cusips"));
const mySiteResourcesCusip9sPathParts = ["my-site", "resources", "cusips"] as const;
export type MySiteResourcesCusip9sPathParts = typeof mySiteResourcesCusip9sPathParts;

const mySiteResourcesCusip9sQuery = t.strict({});
export type MySiteResourcesCusip9sParams = Describe<typeof mySiteResourcesCusip9sPath._A & typeof mySiteResourcesCusip9sQuery._A>;

export type MySiteResourcesCusip9sRoute<A = {}> = { match: Match<MySiteResourcesCusip9sParams & A>; pathParts: MySiteResourcesCusip9sPathParts };

export function mySiteResourcesCusip9sRoute(): MySiteResourcesCusip9sRoute;
export function mySiteResourcesCusip9sRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteResourcesCusip9sParams>): MySiteResourcesCusip9sRoute<t.TypeOf<A>>;
export function mySiteResourcesCusip9sRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteResourcesCusip9sParams>) {
  return {
    match: (q ? mySiteResourcesCusip9sPath.then(query(t.intersection([mySiteResourcesCusip9sQuery, q]))) : mySiteResourcesCusip9sPath.then(query(mySiteResourcesCusip9sQuery))).then(end),
    pathParts: mySiteResourcesCusip9sPathParts,
  };
}

const mySiteResourcesFaqsPath = lit("issuer-portal").then(lit("my-site")).then(lit("resources")).then(lit("faqs"));
const mySiteResourcesFaqsPathParts = ["my-site", "resources", "faqs"] as const;
export type MySiteResourcesFaqsPathParts = typeof mySiteResourcesFaqsPathParts;

const mySiteResourcesFaqsQuery = t.strict({});
export type MySiteResourcesFaqsParams = Describe<typeof mySiteResourcesFaqsPath._A & typeof mySiteResourcesFaqsQuery._A>;

export type MySiteResourcesFaqsRoute<A = {}> = { match: Match<MySiteResourcesFaqsParams & A>; pathParts: MySiteResourcesFaqsPathParts };

export function mySiteResourcesFaqsRoute(): MySiteResourcesFaqsRoute;
export function mySiteResourcesFaqsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteResourcesFaqsParams>): MySiteResourcesFaqsRoute<t.TypeOf<A>>;
export function mySiteResourcesFaqsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteResourcesFaqsParams>) {
  return {
    match: (q ? mySiteResourcesFaqsPath.then(query(t.intersection([mySiteResourcesFaqsQuery, q]))) : mySiteResourcesFaqsPath.then(query(mySiteResourcesFaqsQuery))).then(end),
    pathParts: mySiteResourcesFaqsPathParts,
  };
}

const mySiteResourcesLinksPath = lit("issuer-portal").then(lit("my-site")).then(lit("resources")).then(lit("links"));
const mySiteResourcesLinksPathParts = ["my-site", "resources", "links"] as const;
export type MySiteResourcesLinksPathParts = typeof mySiteResourcesLinksPathParts;

const mySiteResourcesLinksQuery = t.strict({});
export type MySiteResourcesLinksParams = Describe<typeof mySiteResourcesLinksPath._A & typeof mySiteResourcesLinksQuery._A>;

export type MySiteResourcesLinksRoute<A = {}> = { match: Match<MySiteResourcesLinksParams & A>; pathParts: MySiteResourcesLinksPathParts };

export function mySiteResourcesLinksRoute(): MySiteResourcesLinksRoute;
export function mySiteResourcesLinksRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteResourcesLinksParams>): MySiteResourcesLinksRoute<t.TypeOf<A>>;
export function mySiteResourcesLinksRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteResourcesLinksParams>) {
  return {
    match: (q ? mySiteResourcesLinksPath.then(query(t.intersection([mySiteResourcesLinksQuery, q]))) : mySiteResourcesLinksPath.then(query(mySiteResourcesLinksQuery))).then(end),
    pathParts: mySiteResourcesLinksPathParts,
  };
}

const mySiteSiteSettingsColorsAndHeadersPath = lit("issuer-portal").then(lit("my-site")).then(lit("site-settings")).then(lit("colors-and-headers"));
const mySiteSiteSettingsColorsAndHeadersPathParts = ["my-site", "site-settings", "colors-and-headers"] as const;
export type MySiteSiteSettingsColorsAndHeadersPathParts = typeof mySiteSiteSettingsColorsAndHeadersPathParts;

const mySiteSiteSettingsColorsAndHeadersQuery = t.strict({});
export type MySiteSiteSettingsColorsAndHeadersParams = Describe<typeof mySiteSiteSettingsColorsAndHeadersPath._A & typeof mySiteSiteSettingsColorsAndHeadersQuery._A>;

export type MySiteSiteSettingsColorsAndHeadersRoute<A = {}> = { match: Match<MySiteSiteSettingsColorsAndHeadersParams & A>; pathParts: MySiteSiteSettingsColorsAndHeadersPathParts };

export function mySiteSiteSettingsColorsAndHeadersRoute(): MySiteSiteSettingsColorsAndHeadersRoute;
export function mySiteSiteSettingsColorsAndHeadersRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteSiteSettingsColorsAndHeadersParams>): MySiteSiteSettingsColorsAndHeadersRoute<t.TypeOf<A>>;
export function mySiteSiteSettingsColorsAndHeadersRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteSiteSettingsColorsAndHeadersParams>) {
  return {
    match: (q ? mySiteSiteSettingsColorsAndHeadersPath.then(query(t.intersection([mySiteSiteSettingsColorsAndHeadersQuery, q]))) : mySiteSiteSettingsColorsAndHeadersPath.then(query(mySiteSiteSettingsColorsAndHeadersQuery))).then(end),
    pathParts: mySiteSiteSettingsColorsAndHeadersPathParts,
  };
}

const mySiteSiteSettingsDisclaimersPath = lit("issuer-portal").then(lit("my-site")).then(lit("site-settings")).then(lit("disclaimers"));
const mySiteSiteSettingsDisclaimersPathParts = ["my-site", "site-settings", "disclaimers"] as const;
export type MySiteSiteSettingsDisclaimersPathParts = typeof mySiteSiteSettingsDisclaimersPathParts;

const mySiteSiteSettingsDisclaimersQuery = t.strict({});
export type MySiteSiteSettingsDisclaimersParams = Describe<typeof mySiteSiteSettingsDisclaimersPath._A & typeof mySiteSiteSettingsDisclaimersQuery._A>;

export type MySiteSiteSettingsDisclaimersRoute<A = {}> = { match: Match<MySiteSiteSettingsDisclaimersParams & A>; pathParts: MySiteSiteSettingsDisclaimersPathParts };

export function mySiteSiteSettingsDisclaimersRoute(): MySiteSiteSettingsDisclaimersRoute;
export function mySiteSiteSettingsDisclaimersRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteSiteSettingsDisclaimersParams>): MySiteSiteSettingsDisclaimersRoute<t.TypeOf<A>>;
export function mySiteSiteSettingsDisclaimersRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteSiteSettingsDisclaimersParams>) {
  return {
    match: (q ? mySiteSiteSettingsDisclaimersPath.then(query(t.intersection([mySiteSiteSettingsDisclaimersQuery, q]))) : mySiteSiteSettingsDisclaimersPath.then(query(mySiteSiteSettingsDisclaimersQuery))).then(end),
    pathParts: mySiteSiteSettingsDisclaimersPathParts,
  };
}

const mySiteSiteSettingsFooterAndMenuPath = lit("issuer-portal").then(lit("my-site")).then(lit("site-settings")).then(lit("footer-and-menu"));
const mySiteSiteSettingsFooterAndMenuPathParts = ["my-site", "site-settings", "footer-and-menu"] as const;
export type MySiteSiteSettingsFooterAndMenuPathParts = typeof mySiteSiteSettingsFooterAndMenuPathParts;

const mySiteSiteSettingsFooterAndMenuQuery = t.strict({});
export type MySiteSiteSettingsFooterAndMenuParams = Describe<typeof mySiteSiteSettingsFooterAndMenuPath._A & typeof mySiteSiteSettingsFooterAndMenuQuery._A>;

export type MySiteSiteSettingsFooterAndMenuRoute<A = {}> = { match: Match<MySiteSiteSettingsFooterAndMenuParams & A>; pathParts: MySiteSiteSettingsFooterAndMenuPathParts };

export function mySiteSiteSettingsFooterAndMenuRoute(): MySiteSiteSettingsFooterAndMenuRoute;
export function mySiteSiteSettingsFooterAndMenuRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteSiteSettingsFooterAndMenuParams>): MySiteSiteSettingsFooterAndMenuRoute<t.TypeOf<A>>;
export function mySiteSiteSettingsFooterAndMenuRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteSiteSettingsFooterAndMenuParams>) {
  return {
    match: (q ? mySiteSiteSettingsFooterAndMenuPath.then(query(t.intersection([mySiteSiteSettingsFooterAndMenuQuery, q]))) : mySiteSiteSettingsFooterAndMenuPath.then(query(mySiteSiteSettingsFooterAndMenuQuery))).then(end),
    pathParts: mySiteSiteSettingsFooterAndMenuPathParts,
  };
}

const mySiteSiteSettingsPageSetupPath = lit("issuer-portal").then(lit("my-site")).then(lit("site-settings")).then(lit("page-setup"));
const mySiteSiteSettingsPageSetupPathParts = ["my-site", "site-settings", "page-setup"] as const;
export type MySiteSiteSettingsPageSetupPathParts = typeof mySiteSiteSettingsPageSetupPathParts;

const mySiteSiteSettingsPageSetupQuery = t.strict({});
export type MySiteSiteSettingsPageSetupParams = Describe<typeof mySiteSiteSettingsPageSetupPath._A & typeof mySiteSiteSettingsPageSetupQuery._A>;

export type MySiteSiteSettingsPageSetupRoute<A = {}> = { match: Match<MySiteSiteSettingsPageSetupParams & A>; pathParts: MySiteSiteSettingsPageSetupPathParts };

export function mySiteSiteSettingsPageSetupRoute(): MySiteSiteSettingsPageSetupRoute;
export function mySiteSiteSettingsPageSetupRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteSiteSettingsPageSetupParams>): MySiteSiteSettingsPageSetupRoute<t.TypeOf<A>>;
export function mySiteSiteSettingsPageSetupRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteSiteSettingsPageSetupParams>) {
  return {
    match: (q ? mySiteSiteSettingsPageSetupPath.then(query(t.intersection([mySiteSiteSettingsPageSetupQuery, q]))) : mySiteSiteSettingsPageSetupPath.then(query(mySiteSiteSettingsPageSetupQuery))).then(end),
    pathParts: mySiteSiteSettingsPageSetupPathParts,
  };
}

const mySiteSiteSettingsRelatedIssuersPath = lit("issuer-portal").then(lit("my-site")).then(lit("site-settings")).then(lit("related-issuers"));
const mySiteSiteSettingsRelatedIssuersPathParts = ["my-site", "site-settings", "related-issuers"] as const;
export type MySiteSiteSettingsRelatedIssuersPathParts = typeof mySiteSiteSettingsRelatedIssuersPathParts;

const mySiteSiteSettingsRelatedIssuersQuery = t.strict({});
export type MySiteSiteSettingsRelatedIssuersParams = Describe<typeof mySiteSiteSettingsRelatedIssuersPath._A & typeof mySiteSiteSettingsRelatedIssuersQuery._A>;

export type MySiteSiteSettingsRelatedIssuersRoute<A = {}> = { match: Match<MySiteSiteSettingsRelatedIssuersParams & A>; pathParts: MySiteSiteSettingsRelatedIssuersPathParts };

export function mySiteSiteSettingsRelatedIssuersRoute(): MySiteSiteSettingsRelatedIssuersRoute;
export function mySiteSiteSettingsRelatedIssuersRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, MySiteSiteSettingsRelatedIssuersParams>): MySiteSiteSettingsRelatedIssuersRoute<t.TypeOf<A>>;
export function mySiteSiteSettingsRelatedIssuersRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, MySiteSiteSettingsRelatedIssuersParams>) {
  return {
    match: (q ? mySiteSiteSettingsRelatedIssuersPath.then(query(t.intersection([mySiteSiteSettingsRelatedIssuersQuery, q]))) : mySiteSiteSettingsRelatedIssuersPath.then(query(mySiteSiteSettingsRelatedIssuersQuery))).then(end),
    pathParts: mySiteSiteSettingsRelatedIssuersPathParts,
  };
}

const tipsAndToolsBestPracticesPath = lit("issuer-portal").then(lit("tips-and-tools")).then(lit("best-practices"));
const tipsAndToolsBestPracticesPathParts = ["tips-and-tools", "best-practices"] as const;
export type TipsAndToolsBestPracticesPathParts = typeof tipsAndToolsBestPracticesPathParts;

const tipsAndToolsBestPracticesQuery = t.strict({});
export type TipsAndToolsBestPracticesParams = Describe<typeof tipsAndToolsBestPracticesPath._A & typeof tipsAndToolsBestPracticesQuery._A>;

export type TipsAndToolsBestPracticesRoute<A = {}> = { match: Match<TipsAndToolsBestPracticesParams & A>; pathParts: TipsAndToolsBestPracticesPathParts };

export function tipsAndToolsBestPracticesRoute(): TipsAndToolsBestPracticesRoute;
export function tipsAndToolsBestPracticesRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, TipsAndToolsBestPracticesParams>): TipsAndToolsBestPracticesRoute<t.TypeOf<A>>;
export function tipsAndToolsBestPracticesRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, TipsAndToolsBestPracticesParams>) {
  return {
    match: (q ? tipsAndToolsBestPracticesPath.then(query(t.intersection([tipsAndToolsBestPracticesQuery, q]))) : tipsAndToolsBestPracticesPath.then(query(tipsAndToolsBestPracticesQuery))).then(end),
    pathParts: tipsAndToolsBestPracticesPathParts,
  };
}

const tipsAndToolsPersonalizedTipsPath = lit("issuer-portal").then(lit("tips-and-tools")).then(lit("personalized-tips"));
const tipsAndToolsPersonalizedTipsPathParts = ["tips-and-tools", "personalized-tips"] as const;
export type TipsAndToolsPersonalizedTipsPathParts = typeof tipsAndToolsPersonalizedTipsPathParts;

const tipsAndToolsPersonalizedTipsQuery = t.strict({});
export type TipsAndToolsPersonalizedTipsParams = Describe<typeof tipsAndToolsPersonalizedTipsPath._A & typeof tipsAndToolsPersonalizedTipsQuery._A>;

export type TipsAndToolsPersonalizedTipsRoute<A = {}> = { match: Match<TipsAndToolsPersonalizedTipsParams & A>; pathParts: TipsAndToolsPersonalizedTipsPathParts };

export function tipsAndToolsPersonalizedTipsRoute(): TipsAndToolsPersonalizedTipsRoute;
export function tipsAndToolsPersonalizedTipsRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, TipsAndToolsPersonalizedTipsParams>): TipsAndToolsPersonalizedTipsRoute<t.TypeOf<A>>;
export function tipsAndToolsPersonalizedTipsRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, TipsAndToolsPersonalizedTipsParams>) {
  return {
    match: (q ? tipsAndToolsPersonalizedTipsPath.then(query(t.intersection([tipsAndToolsPersonalizedTipsQuery, q]))) : tipsAndToolsPersonalizedTipsPath.then(query(tipsAndToolsPersonalizedTipsQuery))).then(end),
    pathParts: tipsAndToolsPersonalizedTipsPathParts,
  };
}

const tipsAndToolsUserGuidesPath = lit("issuer-portal").then(lit("tips-and-tools")).then(lit("user-guides"));
const tipsAndToolsUserGuidesPathParts = ["tips-and-tools", "user-guides"] as const;
export type TipsAndToolsUserGuidesPathParts = typeof tipsAndToolsUserGuidesPathParts;

const tipsAndToolsUserGuidesQuery = t.strict({});
export type TipsAndToolsUserGuidesParams = Describe<typeof tipsAndToolsUserGuidesPath._A & typeof tipsAndToolsUserGuidesQuery._A>;

export type TipsAndToolsUserGuidesRoute<A = {}> = { match: Match<TipsAndToolsUserGuidesParams & A>; pathParts: TipsAndToolsUserGuidesPathParts };

export function tipsAndToolsUserGuidesRoute(): TipsAndToolsUserGuidesRoute;
export function tipsAndToolsUserGuidesRoute<A extends t.Mixed>(q: NoKeyOverlapC<A, TipsAndToolsUserGuidesParams>): TipsAndToolsUserGuidesRoute<t.TypeOf<A>>;
export function tipsAndToolsUserGuidesRoute<A extends t.Mixed>(q?: NoKeyOverlapC<A, TipsAndToolsUserGuidesParams>) {
  return {
    match: (q ? tipsAndToolsUserGuidesPath.then(query(t.intersection([tipsAndToolsUserGuidesQuery, q]))) : tipsAndToolsUserGuidesPath.then(query(tipsAndToolsUserGuidesQuery))).then(end),
    pathParts: tipsAndToolsUserGuidesPathParts,
  };
}

export const allRoutes = [adminInvoicesRoute, adminSettingsRoute, adminUsersRoute, analyticsCustomReportsRoute, analyticsDocumentActivityRoute, analyticsDocumentStatisticsRoute, analyticsEmailsRoute, analyticsEmailDetailsRoute, analyticsSiteActivityRoute, analyticsUserActivityRoute, analyticsUserProfileRoute, dashboardRoute, debtDataDataManagementRoute, debtDataDataManagementCusip6Route, debtDataDataManagementCustomSeriesRoute, debtDataReviewCenterRoute, debtDataReviewDetailsRoute, debtDataDataManagementSeriesRoute, debtDataDebtProfileRoute, debtDataCustomSeriesBreakdownRoute, debtDataSeriesBreakdownRoute, debtDataYearlyBreakdownRoute, debtDataSettingsRoute, debtDataTagSettingsRoute, marketInsightsRoute, marketInsightsArticleRoute, mySiteAboutRoute, mySiteAboutEsgProgramRoute, mySiteAboutNewsAndEventsRoute, mySiteAboutProjectsRoute, mySiteAboutTeamRoute, mySiteBondsRoute, mySiteBondsParticipantsRoute, mySiteBondsProgramsRoute, mySiteBondsRatingsRoute, mySiteBondsRfpsRoute, mySiteBondsRfpsBidsRoute, mySiteBondsRoadshowsRoute, mySiteChangeApprovalRoute, mySiteCustomPagesRoute, mySiteDocumentsRoute, mySiteDocumentsCategoriesRoute, mySiteDocumentsIrmaLetterRoute, mySiteHomeRoute, mySiteResourcesContactRoute, mySiteResourcesCusip6sRoute, mySiteResourcesCusip9sRoute, mySiteResourcesFaqsRoute, mySiteResourcesLinksRoute, mySiteSiteSettingsColorsAndHeadersRoute, mySiteSiteSettingsDisclaimersRoute, mySiteSiteSettingsFooterAndMenuRoute, mySiteSiteSettingsPageSetupRoute, mySiteSiteSettingsRelatedIssuersRoute, tipsAndToolsBestPracticesRoute, tipsAndToolsPersonalizedTipsRoute, tipsAndToolsUserGuidesRoute] as const;